<!--
 * @Author: zhouxingtong
 * @Email: 495144492@qq.com
 * @Date: 2023-07-26 14:31:05
 * @LastEditors: zhouxingtong
 * @LastEditTime: 2026-01-29 16:13:56
 * @Description: 
-->
<template>
	<div>
		<div class="dashboard-wrap" v-if="isSetPassword">
			<div class="dashboard-empty" v-if="categoryList.length === 0">
				<img src="~@/assets/dashboard-empty.svg" alt="" />
				<p>点击右上角设置按钮，设置店铺信息和包间信息后即可开始使用</p>
			</div>
			<div class="dashboard" v-else>
				<div style="height: 40px" v-if="$store.state.user.info.shop && $store.state.user.info.shop.id === 13">
					<a-alert ref="alert1" banner message="本店铺只用于体验使用预订，输入手机号，预订人可接收预订信息。" type="error" class="absolute left-0 top-0 w-full">
						<template slot="icon">
							<a-icon type="info-circle" style="display: flex" />
						</template>
					</a-alert>
				</div>

				<!-- 余额不足提示 -->
				<div style="height: 40px" v-else-if="storeMoney < 300">
					<a-alert ref="alert1" banner type="error" class="absolute left-0 top-0 w-full">
						<template slot="icon">
							<a-icon type="info-circle" style="display: flex; position: relative; top: 4px" />
						</template>
						<template #message>
							<div>
								<span> 您的备用金已经不足3元，您预订下单后将无法自动给顾客发送短信回执和顾客裂变，您可以在线充值继续使用。 </span>
								<a-button @click="getQRCode" ghost type="primary"> 充值 </a-button>
							</div>
						</template>
					</a-alert>

					<a-modal width="680px" :visible.sync="qrCodeVisible" title="店铺备用金充值" @cancel="visibleCancel" @ok="visibleCancel">
						<template>
							<div class="qr-code mx-auto">
								<a-spin :spinning="qrLoading">
									<img :src="qrCode || require('@/assets/qrcode-empty.png')" alt="二维码" class="w-full cursor-pointer" @click="getQRCode(1)" />
								</a-spin>
							</div>
							<div class="pay-tips mx-auto">
								<a-icon type="scan" style="font-size: 30px; margin-right: 8px" />
								<div>请使用微信扫一扫 扫描二维码支付</div>
							</div>
						</template>
					</a-modal>
				</div>

				<a-tabs size="large" v-model="category" :animated="!isShowSmallCard" @change="handleTabChange">
					<a-tab-pane v-for="item in categoryList" :key="item.id" :tab="item.title">
						<!-- 包间搜索 -->
						<div class="options-bar">
							<div class="options-bar-date">
								<a-button icon="left" class="mr-2" @click="operationDate(false)" />
								<a-date-picker :allowClear="false" :autoFocus="false" :inputReadOnly="true" v-model="orderDate" value-format="YYYY-MM-DD" style="width: calc(100% - 80px)" format="YYYY-MM-DD ddd">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date">
											<span v-if="isTargetDate(current)"
												>{{ current.date() }}<sup style="color: #fff; background: red; padding: 0 2px; border-radius: 50%; font-size: 10px">{{ getTargetDateCount(current) }}</sup></span
											>
											<span v-else>{{ current.date() }}</span>
										</div>
									</template>
								</a-date-picker>
								<a-button icon="right" class="ml-2" @click="operationDate(true)" />
							</div>

							<div>
								<a-radio-group v-model="roomStatus">
									<a-radio-button :value="0">全部</a-radio-button>
									<a-radio-button :value="1">已订</a-radio-button>
									<a-radio-button :value="2">空闲</a-radio-button>
									<a-radio-button :value="3" @click.stop="onQuickSearch(true)">快搜</a-radio-button>
								</a-radio-group>
							</div>

							<div>
								<a-radio-group v-model="orderType" :default-value="orderType">
									<template v-if="holiday && shopConfig.holiday_twice_meal_time">
										<template v-for="(itemMealSegment, indexMealSegment) in mealSegment">
											<template v-if="is_holiday_meal_segment[indexMealSegment] && is_holiday_meal_segment[indexMealSegment] > 1">
												<template v-if="itemMealSegment.open">
													<a-dropdown :placement="'bottomCenter'" :trigger="['click']" :key="`dropdown-${indexMealSegment}`">
														<a-menu slot="overlay">
															<a-menu-item key="1" @click="onChangeMealSegmentRound($event, indexMealSegment, 1)">{{ itemMealSegment.name }}一轮</a-menu-item>
															<a-menu-item key="2" @click="onChangeMealSegmentRound($event, indexMealSegment, 2)">{{ itemMealSegment.name }}二轮</a-menu-item>
														</a-menu>
														<a-radio-button :key="indexMealSegment" :value="indexMealSegment">{{ itemMealSegment.name }}{{ indexMealSegment === orderType && orderRound >= 2 ? '二轮' : '' }} </a-radio-button>
													</a-dropdown>
												</template>
											</template>
											<template v-else>
												<a-radio-button :key="indexMealSegment" @click="onChangeMealSegmentRound($event, indexMealSegment, 1)" :value="indexMealSegment" v-if="itemMealSegment.open">
													{{ itemMealSegment.name }}
												</a-radio-button>
											</template>
										</template>
									</template>
									<template v-else>
										<template v-for="(itemMealSegment, indexMealSegment) in mealSegment">
											<a-radio-button :key="indexMealSegment" :value="indexMealSegment" v-if="itemMealSegment.open">
												{{ itemMealSegment.name }}
											</a-radio-button>
										</template>
									</template>
								</a-radio-group>
							</div>

							<a-space>
								<a-button
									type="primary"
									@click="
										$router.push({
											name: 'BookReview',
											query: {
												orderDate: orderDate,
												orderRound: orderRound,
												orderType: orderType
											}
										})
									">
									预订回访
								</a-button>
								<a-button type="primary" @click="orderRoom()"> 连台连订 </a-button>
								<a-button type="primary" @click="closePrintShowModal()"> 打印接待单 </a-button>
								<a-badge :count="orderNoticeCount">
									<a-button
										type="primary"
										@click="
											$router.push({
												name: 'ChangeLog',
												query: {
													orderNoticeList
												}
											})
											orderNoticeCount = 0
											orderNoticeList = []
										">
										变更记录
										<!-- <router-link to="ChangeLog">变更记录</router-link> -->
									</a-button>
								</a-badge>
							</a-space>

							<div class="status_box">
								<span class="text">状态：</span>
								<div class="status">
									<span class="circle circle_1"></span>
									<span class="text">空闲</span>
								</div>
								<div class="status">
									<span class="circle circle_2"></span>
									<span class="text">已预订</span>
								</div>
								<div class="status">
									<span class="circle circle_3"></span>
									<span class="text">已确认</span>
								</div>
								<div class="status">
									<span class="circle circle_4"></span>
									<span class="text">已到点</span>
								</div>
								<div class="status">
									<span class="circle circle_5"></span>
									<span class="text">客已到/已占座</span>
								</div>
								<div class="status status-line"></div>
								<div class="status status-icon" @click.stop="handleSmallCard">
									<img class="img" :src="require(`@/assets/table-card/${isShowSmallCard ? 'small-card_checked.png' : 'small-card.png'}`)" />
								</div>
								<div class="status status-icon" @click.stop="handleSmallCard">
									<img class="img" :src="require(`@/assets/table-card/${isShowSmallCard ? 'default-card.png' : 'default-card_checked.png'}`)" />
								</div>
							</div>
						</div>

						<!-- 包间内容 -->
						<div class="room-list" v-if="!isShowSmallCard">
							<a-row :gutter="[25, 25]" type="flex" v-if="list.length > 0">
								<!-- 每个包间 -->
								<a-col :xl="{span: 6}" :lg="{span: 8}" :md="{span: 12}" :xs="{span: 24}" v-for="item in list" :key="item.id">
									<!--空闲-->
									<div v-if="item.order === 0" :class="['room', item.status === 0 ? 'disableCart' : '']" @click.stop="orderRoom(item)">
										<div class="room-main">
											<div class="room-status">
												<span class="flex items-center">{{ item.status === 1 ? '空闲' : '禁用' }}</span>
												<span>
													{{ `可坐${item.number}人` }}
												</span>
											</div>
											<div class="room-name" v-if="item.order === 0">
												{{ item.title }}
											</div>
										</div>
										<div class="room-footer">
											<a-row class="w-full h-full" type="flex" align="middle">
												<a-col span="12" class="line-right h-full" v-if="isShowTakeUp">
													<button @click.stop="takeUp(item)" class="w-full h-full text-center">占座</button>
												</a-col>
												<a-col :span="isShowTakeUp ? 12 : 24" class="line-right h-full">
													<button class="w-full h-full text-center">立即预订</button>
												</a-col>
											</a-row>
										</div>
									</div>

									<!--已经预订 、 已经占座、确认-->
									<template v-else-if="item.order === 1">
										<!-- 客已到 -->
										<template v-if="item.order_info.client_arrive === 1">
											<div :class="['room', 'room-active', item.status === 0 ? 'disableCart' : 'is-seat']">
												<div class="room-main">
													<div class="room-status">
														<div class="flex items-center w-4/5">
															<span style="width: 45px">{{ item.status === 1 ? '客已到' : '禁用' }}</span>
															<template v-if="(shopConfig.disable_cancel_change == 1 && item.order_info.mini_user_openid == '') || (shopConfig.disable_cancel_change == 0 && item.status === 1)">
																<img
																	:style="{
																		width: '20px',
																		height: '20px'
																	}"
																	:src="changeRoomSVG"
																	class="ml-2 cursor-pointer inline-block"
																	@click="showChangeRoom(item)" />
															</template>
															<a-icon
																type="picture"
																:style="{
																	fontSize: '20px'
																}"
																class="ml-2 cursor-pointer"
																v-if="item.order_info.remark.image && item.order_info.remark.image.length > 0"
																@click="checkBackupImage(item)" />
														</div>
														<span>
															{{ `${item.order_info.number ? item.order_info.number : ''}${item.order_info.unit ? item.order_info.unit : '人'}` }}
														</span>
													</div>
													<div class="subscribe-info">
														<div class="flex text-dark text-center">
															<div
																:class="[
																	'w-1/2 text-lg font-bold flex',
																	{
																		flexcolumn: item.order_info.name.length > 2
																	}
																]">
																<div class="flex justify-center flex-wrap" style="line-height: 1">
																	<span>
																		{{ `${item.order_info.name}${item.order_info.sex === 1 ? '先生' : item.order_info.sex === 2 ? '女士' : ''}` }}
																	</span>
																	<span v-if="item.order_info.tag" :class="['customer-tag', getTagClassName(item.order_info.tag)]"> {{ item.order_info.tag }}{{ item.order_info.tag != '散客' ? '顾客' : '' }} </span>
																</div>
															</div>
															<div class="w-1/2 room-name-box">
																<div class="text-lg font-bold">
																	{{ item.title }}
																</div>
																<div class="tag" v-if="item.order_info.relation">{{ item.order_info.alias }}</div>
																<!-- <img src="../../../src/assets/even_icon_pc.png" v-if="item.isEven" class="room-name-icon" /> -->
															</div>
														</div>
														<div class="flex text-dark text-center mt-2">
															<div class="w-1/2 text-base">
																{{ item.order_info.phone ? `${item.order_info.phone.slice(0, 3)}****${item.order_info.phone.slice(-4)}` : '无' }}
															</div>
															<div class="w-1/2 text-base">
																{{ item.order_info.order_time }}
															</div>
														</div>
													</div>
												</div>
												<div class="room-footer">
													<a-row style="width: 100%">
														<a-col span="12" class="line-right">
															<a class="font-active block text-center" @click="settlement(item)"> 结算清台 </a>
														</a-col>
														<a-col span="12">
															<board-info :info="item.order_info"></board-info>
														</a-col>
													</a-row>
												</div>
											</div>
										</template>
										<!--已经占座-->
										<template v-if="item.order_info.hold_seat === 1">
											<div :class="['room', 'room-active', item.status === 0 ? 'disableCart' : 'is-seat']">
												<div class="room-main">
													<div class="room-status">
														<span class="flex items-center">{{ item.status === 1 ? '已占座' : '禁用' }}</span>
														<span>
															{{ `${item.number}人` }}
														</span>
													</div>
													<div class="subscribe-info">
														<div class="flex text-dark text-center">
															<div class="w-1/2 text-lg font-bold flex">
																<span> 已占座 </span>
															</div>
															<div class="w-1/2 room-name-box">
																<div class="text-lg font-bold">
																	{{ item.title }}
																</div>
																<div class="tag" v-if="item.order_info.relation">{{ item.order_info.alias }}</div>
																<!-- <img src="../../../src/assets/even_icon_pc.png" v-if="item.isEven" class="room-name-icon" /> -->
															</div>
														</div>
													</div>
												</div>
												<div class="room-footer">
													<a-row style="width: 100%">
														<a-col span="12" class="line-right">
															<a class="font-active block text-center" @click="settlement(item)"> 结算清台 </a>
														</a-col>
														<a-col span="12">
															<board-info :info="item.order_info"></board-info>
														</a-col>
													</a-row>
												</div>
											</div>
										</template>
										<!--已到点-->
										<template v-else-if="item.order_info.isTimeout && item.order_info.client_arrive !== 1">
											<div :class="['room', 'room-active', item.status === 0 ? 'disableCart' : 'is-timeout']">
												<div class="room-main">
													<div class="room-status">
														<div class="flex items-center w-4/5">
															{{ item.status === 1 ? '已到点' : '禁用' }}
															<template v-if="Date.parse(item.order_info.order_date + ' ' + (item.order_info.order_time != '待定' ? item.order_info.order_time : '23:30')) > todayzero && item.status === 1">
																<a-icon
																	type="edit"
																	:style="{
																		fontSize: '20px'
																	}"
																	class="ml-2 cursor-pointer"
																	@click="editOrderRoom(item)" />
																<template v-if="(shopConfig.disable_cancel_change == 1 && item.order_info.mini_user_openid == '') || shopConfig.disable_cancel_change == 0">
																	<img
																		:style="{
																			width: '20px',
																			height: '20px'
																		}"
																		:src="changeRoomSVG"
																		class="ml-2 cursor-pointer inline-block"
																		@click="showChangeRoom(item)" />
																</template>
																<a-icon
																	type="picture"
																	:style="{
																		fontSize: '20px'
																	}"
																	class="ml-2 cursor-pointer"
																	v-if="item.order_info.remark.image && item.order_info.remark.image.length > 0"
																	@click="checkBackupImage(item)" />
															</template>
															<span class="room-remark" :title="item.order_info.remark.text">
																{{ item.order_info.remark.text }}
															</span>
														</div>
														<span>
															{{ `${item.order_info.number ? item.order_info.number : ''}${item.order_info.unit ? item.order_info.unit : '人'}` }}
														</span>
													</div>
													<div class="subscribe-info">
														<div class="flex text-dark text-center">
															<div
																:class="[
																	'w-1/2 text-lg font-bold flex',
																	{
																		flexcolumn: item.order_info.name.length > 2
																	}
																]">
																<div class="flex justify-center flex-wrap" style="line-height: 1">
																	<span>
																		{{ `${item.order_info.name}${item.order_info.sex === 1 ? '先生' : item.order_info.sex === 2 ? '女士' : ''}` }}
																	</span>
																	<span v-if="item.order_info.tag" :class="['customer-tag', getTagClassName(item.order_info.tag)]"> {{ item.order_info.tag }}{{ item.order_info.tag != '散客' ? '顾客' : '' }} </span>
																</div>
															</div>
															<div class="w-1/2 room-name-box">
																<div class="text-lg font-bold">
																	{{ item.title }}
																</div>
																<div class="tag" v-if="item.order_info.relation">{{ item.order_info.alias }}</div>
																<!-- <img src="../../../src/assets/even_icon_pc.png" v-if="item.isEven" class="room-name-icon" /> -->
															</div>
														</div>
														<div class="flex text-dark text-center mt-2">
															<div class="w-1/2 text-base">
																{{ item.order_info.phone ? `${item.order_info.phone.slice(0, 3)}****${item.order_info.phone.slice(-4)}` : '无' }}
															</div>
															<div class="w-1/2 text-base">
																{{ item.order_info.order_time }}
															</div>
														</div>
													</div>
												</div>
												<div class="room-footer">
													<a-row style="width: 100%">
														<a-col span="8" class="line-right">
															<a class="font-active block text-center" @click="clickClientArrive(item)"> 客已到 </a>
														</a-col>
														<a-col span="8" class="line-right">
															<a class="font-active block text-center" @click="showCancelOrder(item)"> 取消预订 </a>
														</a-col>
														<a-col span="8">
															<board-info :info="item.order_info"></board-info>
														</a-col>
													</a-row>
												</div>
											</div>
										</template>
										<!--已确认-->
										<template v-else-if="(item.order_info.confirm === 1 || item.order_info.confirm === 4) && item.order_info.client_arrive !== 1">
											<div :class="['room', 'room-active', item.status === 0 ? 'disableCart' : 'is-submit']">
												<div class="room-main">
													<div class="room-status">
														<div class="flex items-center w-4/5">
															<template v-if="Date.parse(item.order_info.order_date + ' ' + (item.order_info.order_time != '待定' ? item.order_info.order_time : '23:30')) / 1000 > today && item.status === 1">
																{{ item.status === 1 ? '已确认' : '禁用' }}
																<a-icon
																	type="edit"
																	class="ml-2 cursor-pointer"
																	:style="{
																		fontSize: '20px'
																	}"
																	@click="editOrderRoom(item)" />
																<template v-if="(shopConfig.disable_cancel_change == 1 && item.order_info.mini_user_openid == '') || shopConfig.disable_cancel_change == 0">
																	<img
																		:style="{
																			width: '20px',
																			height: '20px'
																		}"
																		:src="changeRoomSVG"
																		class="ml-2 cursor-pointer inline-block"
																		@click="showChangeRoom(item)" />
																</template>
																<a-icon
																	type="picture"
																	:style="{
																		fontSize: '20px'
																	}"
																	class="ml-2 cursor-pointer"
																	v-if="item.order_info.remark.image && item.order_info.remark.image.length > 0"
																	@click="checkBackupImage(item)" />
															</template>
															<span class="room-remark" :title="item.order_info.remark.text">
																{{ item.order_info.remark.text }}
															</span>
														</div>
														<span>
															{{ `${item.order_info.number ? item.order_info.number : ''}${item.order_info.unit ? item.order_info.unit : '人'}` }}
														</span>
													</div>
													<div class="subscribe-info">
														<div class="flex text-dark text-center">
															<div
																:class="[
																	'w-1/2 text-lg font-bold flex',
																	{
																		flexcolumn: item.order_info.name.length > 2
																	}
																]">
																<div class="flex justify-center flex-wrap" style="line-height: 1">
																	<span>
																		{{ `${item.order_info.name}${item.order_info.sex === 1 ? '先生' : item.order_info.sex === 2 ? '女士' : ''}` }}
																	</span>
																	<span v-if="item.order_info.tag" :class="['customer-tag', getTagClassName(item.order_info.tag)]"> {{ item.order_info.tag }}{{ item.order_info.tag != '散客' ? '顾客' : '' }} </span>
																</div>
															</div>
															<div class="w-1/2 room-name-box">
																<div class="text-lg font-bold">
																	{{ item.title }}
																</div>
																<div class="tag" v-if="item.order_info.relation">{{ item.order_info.alias }}</div>
																<!-- <img src="../../../src/assets/even_icon_pc.png" v-if="item.isEven" class="room-name-icon" /> -->
															</div>
														</div>
														<div class="flex text-dark text-center mt-2">
															<div class="w-1/2 text-base">
																{{ item.order_info.phone ? `${item.order_info.phone.slice(0, 3)}****${item.order_info.phone.slice(-4)}` : '无' }}
															</div>
															<div class="w-1/2 text-base">
																{{ item.order_info.order_time }}
															</div>
														</div>
													</div>
												</div>
												<div class="room-footer">
													<a-row style="width: 100%">
														<a-col span="8" class="line-right">
															<a class="font-active block text-center" @click="clickClientArrive(item)"> 客已到 </a>
														</a-col>
														<a-col span="8" class="line-right">
															<a class="font-active block text-center" @click="showCancelOrder(item)"> 取消预订 </a>
														</a-col>
														<a-col span="8">
															<board-info :info="item.order_info"></board-info>
														</a-col>
													</a-row>
												</div>
											</div>
										</template>
										<!--已预订-->
										<template v-else-if="item.order_info.client_arrive !== 1">
											<div :class="['room', 'room-active', item.status === 0 ? 'disableCart' : 'is-booking']">
												<div class="room-main">
													<div class="room-status">
														<div class="flex items-center w-4/5">
															<span style="width: 45px">{{ item.status === 1 ? '已预订' : '禁用' }}</span>
															<template v-if="Date.parse(item.order_info.order_date + ' ' + (item.order_info.order_time != '待定' ? item.order_info.order_time : '23:30')) / 1000 > today && item.status === 1">
																<a-icon
																	type="edit"
																	class="ml-2 cursor-pointer"
																	:style="{
																		fontSize: '20px'
																	}"
																	@click="editOrderRoom(item)" />

																<template v-if="item.order_info.with_a_map_order">
																	<img style="margin-left: 6px; cursor: pointer; width: 20px; height: 20px" @click="showAMapTip($event, 1)" src="https://luyopay-djbj.oss-accelerate-overseas.aliyuncs.com/mini/amap/pc_amap_icon2.png" v-if="item.order_info.with_a_map_order.reschedule == 1" />
																	<img style="margin-left: 6px; cursor: pointer; width: 20px; height: 20px" @click="showAMapTip($event, 2, item.order_info.with_a_map_order)" src="https://luyopay-djbj.oss-accelerate-overseas.aliyuncs.com/mini/amap/pc_amap_icon1.png" v-if="item.order_info.with_a_map_order.latestEta" />
																</template>

																<template v-if="(shopConfig.disable_cancel_change == 1 && item.order_info.mini_user_openid == '') || shopConfig.disable_cancel_change == 0">
																	<img
																		:style="{
																			width: '20px',
																			height: '20px'
																		}"
																		:src="changeRoomSVG"
																		class="ml-2 cursor-pointer inline-block"
																		@click="showChangeRoom(item)" />
																</template>
																<a-icon
																	type="picture"
																	:style="{
																		fontSize: '20px'
																	}"
																	class="ml-2 cursor-pointer"
																	v-if="item.order_info.remark.image && item.order_info.remark.image.length > 0"
																	@click="checkBackupImage(item)" />
															</template>
															<span class="room-remark" :title="item.order_info.remark.text">
																{{ item.order_info.remark.text }}
															</span>
														</div>
														<span>
															{{ `${item.order_info.number ? item.order_info.number : ''}${item.order_info.unit ? item.order_info.unit : '人'}` }}
														</span>
													</div>
													<div class="subscribe-info">
														<div class="flex text-dark text-center">
															<div
																:class="[
																	'w-1/2 text-lg font-bold flex',
																	{
																		flexcolumn: item.order_info.name.length > 2
																	}
																]">
																<div class="flex justify-center flex-wrap" style="line-height: 1">
																	<span>
																		{{ `${item.order_info.name}${item.order_info.sex === 1 ? '先生' : item.order_info.sex === 2 ? '女士' : ''}` }}
																	</span>
																	<span v-if="item.order_info.tag" :class="['customer-tag', getTagClassName(item.order_info.tag)]"> {{ item.order_info.tag }}{{ item.order_info.tag != '散客' ? '顾客' : '' }} </span>
																</div>
															</div>
															<div class="w-1/2 room-name-box">
																<div class="text-lg font-bold">
																	{{ item.title }}
																</div>
																<div class="tag" v-if="item.order_info.relation">{{ item.order_info.alias }}</div>
																<!-- <img src="../../../src/assets/even_icon_pc.png" v-if="item.isEven" class="room-name-icon" /> -->
															</div>
														</div>
														<div class="flex text-dark text-center mt-2">
															<div class="w-1/2 text-base">
																{{ item.order_info.phone ? `${item.order_info.phone.slice(0, 3)}****${item.order_info.phone.slice(-4)}` : '无' }}
															</div>
															<div class="w-1/2 text-base">
																{{ item.order_info.order_time }}
															</div>
														</div>
													</div>
												</div>
												<div class="room-footer">
													<a-row style="width: 100%">
														<a-col span="8" class="line-right">
															<a class="font-active block text-center" @click="clickClientArrive(item)"> 客已到 </a>
														</a-col>
														<a-col span="8" class="line-right">
															<a class="font-active block text-center" @click="showCancelOrder(item)"> 取消预订 </a>
														</a-col>
														<a-col span="8">
															<board-info :info="item.order_info"></board-info>
														</a-col>
													</a-row>
												</div>
											</div>
										</template>
									</template>
								</a-col>
							</a-row>
							<div class="dashboard-empty room-list-empty" v-else>
								<img src="~@/assets/dashboard-empty.svg" alt="" />
								<p>暂无可用包间</p>
							</div>
						</div>

						<!-- 小卡片显示 -->
						<div class="room-small-card" v-else>
							<div v-for="item_child in list" :key="item_child.id" :id="'category-' + item_child.categoryId">
								<div class="card-title">{{ item_child.categoryName }}</div>
								<div class="card-list">
									<div v-for="item_room in item_child.roomList" :key="item_room.id">
										<!-- 空闲 -->
										<div :class="[item_room.status === 0 ? 'disableCart' : '']">
											<div class="card-item card-status-00" v-if="item_room.order === 0" @click.stop="orderRoom(item_room)">
												<p class="item-name">{{ item_room.title }}</p>
												<div class="item-line" v-if="isShowTakeUp"></div>
												<div class="item-info">
													<p>{{ item_room.number }}人</p>
												</div>
												<div class="item-bottom" v-if="isShowTakeUp && item_room.status === 1" @click.stop="takeUp(item_room)">占座</div>
												<img class="item-status" v-if="item_room.status === 0" :src="require('@/assets/table-card/card-status-03.png')" />
											</div>
											<template v-else-if="item_room.order === 1">
												<!-- 客已到 -->
												<div class="card-item card-item-checked card-status-05" v-if="item_room.order_info.client_arrive === 1" @click.stop="onCheckDetail(item_room)">
													<div class="tag" v-if="item_room.order_info.relation">{{ item_room.order_info.alias }}</div>
													<p class="item-name">{{ item_room.title }}</p>
													<div class="item-info">
														<p>{{ `${item_room.order_info.name}${item_room.order_info.sex === 1 ? '先生' : item_room.order_info.sex === 2 ? '女士' : ''}` }}</p>
														<div class="remark" v-if="item_room.order_info.remark.text">注</div>
													</div>
													<p class="item-phone">{{ item_room.order_info.phone ? `${item_room.order_info.phone.slice(0, 3)}****${item_room.order_info.phone.slice(-4)}` : '无' }}</p>
													<img class="item-status" :src="require(item_room.status === 0 ? '@/assets/table-card/card-status-03.png' : '@/assets/table-card/card-status-06.png')" />
												</div>
												<!-- 已占座 -->
												<div class="card-item card-item-checked card-status-05" v-if="item_room.order_info.hold_seat === 1" @click="settlement(item_room)">
													<p class="item-name">{{ item_room.title }}</p>
													<div class="item-info">
														<p>销售：{{ item_room.order_info.with_mini_bind_user ? item_room.order_info.with_mini_bind_user.nickname : '终端' }}</p>
													</div>
													<p class="item-phone">{{ `${item_room.number}人` }}</p>
													<img class="item-status" :src="require(item_room.status === 0 ? '@/assets/table-card/card-status-03.png' : '@/assets/table-card/card-status-05.png')" />
												</div>
												<!-- 已到点 -->
												<div class="card-item card-item-checked card-status-02" v-else-if="item_room.order_info.isTimeout && item_room.order_info.client_arrive !== 1" @click.stop="onCheckDetail(item_room)">
													<div class="tag" v-if="item_room.order_info.relation">{{ item_room.order_info.alias }}</div>
													<p class="item-name">{{ item_room.title }}</p>
													<div class="item-info">
														<p>{{ `${item_room.order_info.name}${item_room.order_info.sex === 1 ? '先生' : item_room.order_info.sex === 2 ? '女士' : ''}` }}</p>
														<div class="remark" v-if="item_room.order_info.remark.text">注</div>
													</div>
													<p class="item-phone">{{ item_room.order_info.phone ? `${item_room.order_info.phone.slice(0, 3)}****${item_room.order_info.phone.slice(-4)}` : '无' }}</p>
													<img class="item-status" :src="require(item_room.status === 0 ? '@/assets/table-card/card-status-03.png' : '@/assets/table-card/card-status-07.png')" />
												</div>
												<!-- 已确认 -->
												<div class="card-item card-item-checked card-status-04" v-else-if="(item_room.order_info.confirm === 1 || item_room.order_info.confirm === 4) && item_room.order_info.client_arrive !== 1" @click.stop="onCheckDetail(item_room)">
													<div class="tag" v-if="item_room.order_info.relation">{{ item_room.order_info.alias }}</div>
													<p class="item-name">{{ item_room.title }}</p>
													<div class="item-info">
														<p>{{ `${item_room.order_info.name}${item_room.order_info.sex === 1 ? '先生' : item_room.order_info.sex === 2 ? '女士' : ''}` }}</p>
														<div class="remark" v-if="item_room.order_info.remark.text">注</div>
													</div>
													<p class="item-phone">{{ item_room.order_info.phone ? `${item_room.order_info.phone.slice(0, 3)}****${item_room.order_info.phone.slice(-4)}` : '无' }}</p>
													<img class="item-status" :src="require(item_room.status === 0 ? '@/assets/table-card/card-status-03.png' : '@/assets/table-card/card-status-04.png')" />
												</div>
												<!-- 已预订 -->
												<div class="card-item card-item-checked card-status-01" v-else-if="item_room.order_info.client_arrive !== 1" @click.stop="onCheckDetail(item_room)">
													<div class="tag" v-if="item_room.order_info.relation">{{ item_room.order_info.alias }}</div>
													<p class="item-name">{{ item_room.title }}</p>
													<div class="item-info">
														<p>{{ `${item_room.order_info.name}${item_room.order_info.sex === 1 ? '先生' : item_room.order_info.sex === 2 ? '女士' : ''}` }}</p>
														<div class="remark" v-if="item_room.order_info.remark.text">注</div>
													</div>
													<p class="item-phone">{{ item_room.order_info.phone ? `${item_room.order_info.phone.slice(0, 3)}****${item_room.order_info.phone.slice(-4)}` : '无' }}</p>
													<img class="item-status" :src="require(item_room.status === 0 ? '@/assets/table-card/card-status-03.png' : '@/assets/table-card/card-status-01.png')" />
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
					</a-tab-pane>
				</a-tabs>
			</div>
		</div>
		<div class="first-login" v-else>
			<div class="first-login-form">
				<h3 class="text-center font-bold text-xl mt-6 mb-6">设置操作密码</h3>
				<a-form-model ref="password" :model="passwordForm" :label-col="{span: 6}" :wrapper-col="{span: 18}">
					<a-form-model-item
						label="后台设置密码"
						prop="password"
						:rules="{
							required: true,
							message: '请输入密码',
							pattern: /^[a-zA-Z0-9`!@#$%^&*()_+.]+$/
						}">
						<template #help>
							<p class="first-login-help">此密码用于后台右上角进入“设置”，请牢记该密码，以便后期使用。</p>
						</template>
						<a-input v-model.trim="passwordForm.password" type="password" placeholder="请输入密码" />
					</a-form-model-item>
					<div class="flex justify-center items-center mt-9">
						<a-button type="primary" size="large" @click="savePassword"> 保存 </a-button>
					</div>
				</a-form-model>
			</div>
		</div>
		<div class="scroll-top" @click="onScrollTop">
			<img class="" src="@/assets/table-card/scroll-top.png" />
		</div>
		<div class="scroll-refresh" @click="onScrollRefresh">
			<img class="" src="@/assets/table-card/scroll-refresh.png" />
		</div>
		<!-- 小卡片详情 modal -->
		<a-modal v-model="isShowOrderDetail" title="订单详情" :footer="null" @cancel="handleCloseDetail">
			<div :class="['detail-wrapper', `detail-wrapper-${handleModalOrderStatus(modalOrderDetail)}`]">
				<div :class="['detail-status', `detail-status-${handleModalOrderStatus(modalOrderDetail)}`]">订单状态：{{ handleModalOrderStatus(modalOrderDetail, 'name') }}</div>
				<div class="detail-title">订单详情</div>
				<div class="detail-row">
					<p>接待经理：{{ modalOrderDetail?.order_info?.with_mini_bind_user?.nickname }}</p>
					<p>预计到店人数：{{ modalOrderDetail?.order_info?.unit === '待定' ? '' : modalOrderDetail?.order_info?.number }}{{ modalOrderDetail.order_info?.unit }}</p>
				</div>
				<div class="detail-row">
					<p>预订人：{{ formatUserInfo(modalOrderDetail?.order_info) }}</p>
					<p>预计到店日期：{{ modalOrderDetail?.order_info?.order_date }}</p>
				</div>
				<div class="detail-row">
					<p>性别：{{ formatUserInfo(modalOrderDetail?.order_info, 'sex') }}</p>
					<p>预计到店时间：{{ modalOrderDetail?.order_info?.order_time }}</p>
				</div>
				<div class="detail-row">
					<p>手机号：{{ formatUserInfo(modalOrderDetail?.order_info, 'phone') }}</p>
					<p>邀请函样式：{{ formatInvitationType(modalOrderDetail?.order_info) }}</p>
				</div>
				<div class="detail-row">
					<p>备注：{{ modalOrderDetail?.order_info?.remark?.text }}<span class="detail-row-check" v-if="modalOrderDetail?.order_info?.remark?.image.length > 0" @click="checkBackupImage(modalOrderDetail)">查看备注图片</span></p>
				</div>
			</div>
			<div class="flex items-center options-wrapper">
				<template v-if="['01', '02', '04', '05'].includes(handleModalOrderStatus(modalOrderDetail)) && modalOrderDetail.order_info.hold_seat !== 1">
					<div class="flex justify-center items-center options-item" @click.stop="editOrderRoom(modalOrderDetail)">
						<img class="options-icon" src="../../assets/table-card/options-edit.png" />
						<p>编辑订单</p>
					</div>
					<div class="flex justify-center items-center options-item" @click.stop="showChangeRoom(modalOrderDetail)">
						<img class="options-icon" src="../../assets/table-card/options-exchange.png" />
						<p>转台</p>
					</div>
					<div class="flex justify-center items-center options-item" v-if="modalOrderDetail.order_info.client_arrive === 1" @click.stop="settlement(modalOrderDetail)">
						<img class="options-icon" src="../../assets/table-card/options-arrive.png" />
						<p>结算清台</p>
					</div>
					<div class="flex justify-center items-center options-item" v-else @click.stop="clickClientArrive(modalOrderDetail)">
						<img class="options-icon" src="../../assets/table-card/options-arrive.png" />
						<p>客已到</p>
					</div>
					<div class="flex justify-center items-center options-item" @click.stop="showCancelOrder(modalOrderDetail)">
						<img class="options-icon" src="../../assets/table-card/options-clean.png" />
						<p>取消</p>
					</div>
				</template>
				<div class="flex justify-center items-center options-item" v-else @click.stop="settlement(modalOrderDetail)">
					<img class="options-icon" src="../../assets/table-card/options-clean.png" />
					<p>结算清台</p>
				</div>
			</div>
		</a-modal>
		<!-- 结算清台 modal -->
		<a-modal
			dialog-class="modal-content"
			title="结算清台"
			okText="结算清台"
			width="600px"
			:mask-closable="false"
			:visible.sync="settlementVisible"
			@cancel="
				settlementForm = {}
				$refs.settlement.clearValidate()
				settlementVisible = false
			"
			@ok="settlementConfirm">
			<a-form-model ref="settlement" :model="settlementForm" :label-col="{span: 4}" :wrapper-col="{span: 20}">
				<template v-if="settlementForm.order_info && settlementForm.order_info.with_corp_user">
					<a-form-model-item label="包间名">
						{{ settlementForm.title }}
					</a-form-model-item>
					<a-form-model-item label="销售">
						<template v-if="settlementForm.order_info.with_corp_user && settlementForm.order_info.with_corp_user.name">
							{{ settlementForm.order_info.with_corp_user.name }}
						</template>
						<ww-open-data v-else type="userName" :openid="settlementForm.order_info.with_corp_user && settlementForm.order_info.with_corp_user.userid" />
					</a-form-model-item>
				</template>
				<a-form-model-item
					prop="money"
					label="销售额"
					:rules="{
						required: true,
						message: '请输入消费总额',
						min: 0
					}">
					<a-input v-model="settlementForm.money" placeholder="请输入消费总额" :min="0" type="number" addon-after="元" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 预订 modal -->
		<a-modal width="780px" okText="提交预订" :title="orderTitle" :mask-closable="false" :visible.sync="orderVisible" :dialog-style="{top: '20px'}" @cancel="onCancelOrderRoom" @ok="orderRoomConfirm(1)">
			<template slot="footer" v-if="isNoteServe">
				<template v-if="(currentOrderForm.mini_user_openid == '' && shopConfig.disable_cancel_change == 1) || !currentOrderForm.id || shopConfig.disable_cancel_change == 0">
					<a-button @click="orderRoomConfirm(0)" type="secondary" :loading="orderLoading"> 提交预订</a-button>
					<a-button @click="orderRoomConfirm(1)" type="primary" :loading="orderLoading">提交预订并发送短信</a-button>
				</template>
				<template v-else>
					{{ null }}
				</template>
			</template>
			<a-form-model ref="order" :model="currentOrderForm" :label-col="{span: 6}" :wrapper-col="{span: 17}">
				<a-form-model-item label="日期" v-if="isShowMoreMeal && rangeDateArray.length">
					<a-row>
						<a-col span="10" v-if="rangeDateArray.length > 1">{{ rangeDateArray[0].date }}至{{ rangeDateArray[rangeDateArray.length - 1].date }}</a-col>
						<a-col span="10" v-else>{{ rangeDateArray[0].date }}</a-col>
						<a-col span="14" class="text-center">就餐类型：{{ moreMealForm.type === '1' ? '全天' : rangePickerUniqueMeals.length ? rangePickerUniqueMeals.map(index => mealSegment[index].name).join('/') : '' }}</a-col>
					</a-row>
				</a-form-model-item>

				<a-form-model-item label="日期" v-else>
					<a-row>
						<a-col span="6">{{ orderDate }}</a-col>
						<a-col span="6" class="text-left"> {{ currentOrderForm.title ? '类型' : '就餐类型' }}：{{ orderTypeName }}{{ orderRound > 1 ? '二轮' : '' }}</a-col>
						<a-col span="12" class="text-center" v-if="currentOrderForm.title"> 包间名：{{ currentOrderForm.title }} <a-button type="primary" class="ml-4" @click="onHandleAddRooms" v-if="currentOrderForm.id">加桌</a-button></a-col>
					</a-row>
				</a-form-model-item>

				<a-form-model-item prop="isShowMoreMeal" label="多餐段连订" v-if="!currentOrderForm.title">
					<!-- <a-space>
						<a-button type="primary" v-if="isShowMoreMeal" @click="onHandleMoreMealPopup">选择日期和餐段</a-button>
					</a-space> -->
					<a-button type="primary" @click="onHandleMoreMealPopup">选择日期和餐段</a-button>
				</a-form-model-item>

				<a-form-model-item
					v-if="!currentOrderForm.title || (isShowRoomList && currentOrderForm.id)"
					:rules="{
						required: true,
						message: isShowRoomList ? '请选择加桌包间' : '请选择连台包间'
					}"
					prop="room_id"
					:label="isShowRoomList ? '选择加桌包间' : '选择包间'">
					<a-tree-select
						ref="roomTreeSelect"
						v-model="currentOrderForm.room_id"
						tree-data-simple-mode
						tree-checkable
						style="width: 100%"
						placeholder="请选择连台包间"
						:tree-data="roomTreeData"
						:show-checked-strategy="SHOW_PARENT"
						:load-data="onLoadData"
						:expanded-keys.sync="expandedKeys"
						:multiple="true"
						:dropdown-style="{
							maxHeight: '200px',
							overflow: 'auto'
						}"
						@change="onChangeTreeSelect" />
				</a-form-model-item>

				<template v-if="orderTitle === '为顾客订包间'">
					<!--有Corpid-->
					<a-form-model-item v-if="hasCorpId" prop="corp_user_id" label="接待人">
						<a-select v-model="currentOrderForm.corp_user_id" allowClear class="search-bar-input" placeholder="请选择接待人">
							<a-select-option v-for="item in employeeList" :key="item.id" :value="item.id">
								<template v-if="item.name">{{ item.name }}</template>
								<ww-open-data v-else type="userName" :openid="item.userid" />
							</a-select-option>
						</a-select>
					</a-form-model-item>
					<!--没有有Corpid-->
					<a-form-model-item v-else prop="mini_user_openid" label="接待人">
						<a-select v-model="currentOrderForm.mini_user_openid" placeholder="请选择接待人">
							<a-select-option :value="item.openid" v-for="item in employeeList" :key="item.id">
								{{ item.nickname || (item.mini_user && item.mini_user.nickname) || '' }}
							</a-select-option>
						</a-select>
					</a-form-model-item>
				</template>
				<a-form-model-item
					:rules="{
						max: 30,
						required: true,
						message: '请输入预订人（不超过30个字符）'
					}"
					prop="name"
					label="预订人">
					<a-input v-model="currentOrderForm.name" placeholder="贵姓" />
				</a-form-model-item>
				<a-form-model-item prop="sex" label="性别">
					<a-radio-group v-model="currentOrderForm.sex">
						<a-radio :value="1">先生</a-radio>
						<a-radio :value="2">女士</a-radio>
						<a-radio :value="0">无</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<!--1.5改动：手机号不是必填项，但是必须展示星号。使用自定义校验函数。-->
				<a-form-model-item
					prop="phone"
					label="手机号"
					:rules="{
						required: mustNeedPhone === 1 ? true : false,
						message: '请输入正确的手机号'
					}">
					<a-input v-model="currentOrderForm.phone" placeholder="手机号" type="tel" :max-length="11" />
				</a-form-model-item>
				<a-form-model-item :rules="{required: currentOrderForm.unit === '待定' ? false : true, message: '请输入预计到店人数'}" prop="number" label="预计到店人数">
					<a-input v-model="currentOrderForm.number" :disabled="currentOrderForm.unit === '待定' ? true : false" placeholder="预计到店人数">
						<template #addonAfter>
							<a-select v-model="currentOrderForm.unit">
								<a-select-option value="人">人</a-select-option>
								<a-select-option value="桌">桌</a-select-option>
								<a-select-option value="待定">待定</a-select-option>
							</a-select>
						</template>
					</a-input>
				</a-form-model-item>
				<!-- #2666隐藏编辑订单中的日期选择 -->
				<!-- <a-form-model-item
					v-if="orderTitle === '修改包间预订信息'"
					:rules="{ required: true, message: '请选择预计到店时间' }"
					prop="order_time"
					label="预计到店日期">
					<a-date-picker
						v-model="currentOrderForm.order_date"
						style="width: 100%"
						placeholder="预计到店日期"
						value-format="YYYY-MM-DD" />
				</a-form-model-item> -->
				<template v-if="isShowMoreMeal && rangePickerUniqueMeals.length">
					<a-form-model-item
						:rules="{
							required: true,
							message: ''
						}"
						:prop="'rangeOrderTimes'"
						:label="'预计到店时间(' + mealSegment[item].name + ')'"
						v-for="(item, index) in rangePickerUniqueMeals"
						:key="index"
						v-if="mealSegment[item].open">
						<a-button
							@click="
								rangeOrderType = item
								showOrderTime = true
							">
							{{ rangeOrderTimes[item] || '请选择预计到店时间' }}
						</a-button>
					</a-form-model-item>
				</template>
				<template v-else-if="isShowMoreMeal && rangeAllOrderTimes.length && !rangePickerUniqueMeals.length">
					<a-form-model-item
						:rules="{
							required: true,
							message: ''
						}"
						prop="rangeAllOrderTimesValue"
						label="预计到店时间">
						<a-button @click="showOrderTime = true">
							{{ rangeAllOrderTimesValue || '请选择预计到店时间' }}
						</a-button>
					</a-form-model-item>
				</template>
				<a-form-model-item :rules="{required: true, message: '请选择预计到店时间'}" prop="order_time" label="预计到店时间" v-else>
					<div class="time-list">
						<div
							:class="{
								'time-item': true,
								'time-item-active': currentOrderForm.order_time === item
							}"
							v-for="item in timeList[orderType]"
							:key="item"
							@click="$set(currentOrderForm, 'order_time', item)">
							{{ item }}
						</div>
						<a-time-picker v-model="customOrderTime" format="HH:mm" placeholder="自定义时间" size="large" :getPopupContainer="node => node.parentNode" @change="val => $set(currentOrderForm, 'order_time', val ? val.format('HH:mm') : '')" @openChange="onChangePanel" />
					</div>
				</a-form-model-item>
				<a-form-model-item prop="type" label="邀请函样式">
					<a-card title="马年新春限定" style="width: 100%">
						<a-radio-group v-model="typeActivity" :options="activityTypes" @change="onBanquet(false)" />
					</a-card>
					<a-card title="经典样式" style="width: 100%">
						<a slot="extra">
							<template>
								<a-switch v-model="currentOrderForm.type_version" @change="onChangeTypeVersion" />
							</template>
							使用样式2
						</a>
						<a-radio-group v-model="typeClassic" :options="orderTypes" @change="onBanquet(false)" />
					</a-card>
					<a-card title="人生三十六宴" :loading="banquetLoading" style="width: 100%" v-if="banquetList && banquetList.length">
						<a slot="extra"
							>自定义主题图
							<template v-if="banqueInfo.id">
								:<a-avatar :src="banqueInfo.cover_img" />
								{{ banqueInfo.feast_name ? `${banqueInfo.feast_name}` : '' }}
							</template>
						</a>
						<a-collapse v-model="banquetActiveKey">
							<a-collapse-panel v-for="(item, index) in banquetList" :key="item.id.toString()" :header="item.name" :disabled="item.with_life_feasts.length ? false : true">
								<a-radio-group button-style="solid" v-model="currentOrderForm.type" :disabled="item.disabled" class="banquetListRadion">
									<a-radio-button style="white-space: nowrap; padding: 5px 15px; height: auto" :value="`${item.id}_${items.id}`" v-for="items in item.with_life_feasts" :key="items.id" @click="onBanquet(items)">
										<a-avatar :src="items.cover_img" />
										{{ items.name }}
									</a-radio-button>
								</a-radio-group>
							</a-collapse-panel>
						</a-collapse>
					</a-card>
				</a-form-model-item>
				<template v-if="banqueInfo.id">
					<a-form-model-item label="宴席主宾姓名/称呼">
						<a-input v-model="banqueInfo.name" placeholder="请输入宴席主宾姓名/称呼" />
					</a-form-model-item>
					<a-form-model-item ref="themeImg" label="自定义邀请函主题图片">
						<a-upload
							:show-upload-list="false"
							v-if="!banqueInfo.theme_img"
							:before-upload="
								file => {
									upBanqueInfoImage(file, 'theme_img')
								}
							"
							accept="image/*">
							<a-button type="primary" size="large">
								<a-icon type="cloud-upload" />
								上传图片
							</a-button>
						</a-upload>
						<image-uploader v-else v-model="banqueInfo.theme_img" @success="$refs.themeImg.onFieldBlur()" @remove="$refs.themeImg.onFieldBlur()" />
					</a-form-model-item>
					<a-form-model-item ref="invitationImg" label="自定义邀请函转发封面">
						<a-upload
							:show-upload-list="false"
							v-if="!banqueInfo.invitation_img"
							:before-upload="
								file => {
									upBanqueInfoImage(file, 'invitation_img')
								}
							"
							accept="image/*">
							<a-button type="primary" size="large">
								<a-icon type="cloud-upload" />
								上传图片
							</a-button>
						</a-upload>
						<image-uploader v-else v-model="banqueInfo.invitation_img" @success="$refs.invitationImg.onFieldBlur()" @remove="$refs.invitationImg.onFieldBlur()" />
					</a-form-model-item>
					<!-- <a-form-model-item ref="menuImg" label="邀请函自定义排菜图片">
						<a-upload :show-upload-list="false"
						:before-upload="(file)=>{upBanqueInfoImage(file,'menu_img')}"
						accept="image/*"
						v-if="!banqueInfo.menu_img"
						>
							<a-button type="primary" size="large">
								<a-icon type="cloud-upload" />
								上传图片
							</a-button>
						</a-upload>
						<image-uploader v-else v-model="banqueInfo.menu_img"  @success="$refs.menuImg.onFieldBlur()" @remove="$refs.menuImg.onFieldBlur()"  />
					</a-form-model-item> -->
				</template>
				<a-form-model-item prop="open_menu" label="客户预点菜" v-if="shopConfig.show_order_dishes && shopConfig.show_order_dishes === 1">
					<a-switch default-checked v-model="currentOrderForm.open_menu" />
				</a-form-model-item>
				<a-form-model-item label="定金">
					<a-button type="text" @click="addReservation" :disabled="reservationInfo.list.length >= 3 ? true : false" icon="plus" :style="reservationInfo.list.length >= 3 ? '' : 'color: #E63E30;border-color: #E63E30;'">添加定金</a-button>
				</a-form-model-item>
				<!-- 新增定金列表 -->
				<template v-if="reservationInfo.list.length">
					<template v-for="(item, index) in reservationInfo.list">
						<a-form-model-item :label="'定金' + (index + 1)" :key="`deposit-${index}`">
							<template v-if="item.receipt_number">
								{{ item.receipt_number }}
							</template>
							<a-button icon="delete" :style="item.reservationType <= 1 ? 'color: #E63E30;border-color: #E63E30;' : ''" @click="onDeleteReservationInfo(index)" :disabled="item.reservationType >= 2 ? true : false">
								<template v-if="item.reservationType === 2"> 已核销 </template>
								<template v-else-if="item.reservationType === 3"> 已打印 </template>
								<template v-else-if="item.reservationType === 4"> 已退款 </template>
								<template v-else> 删除 </template>
							</a-button>
						</a-form-model-item>
						<a-form-model-item :rules="{required: true, validator: (rule, value, callback) => callback()}" label="定金金额" :key="`deposit-amount-${index}`">
							<a-input v-model.number="item.pay_money" @change="payMoneyChange(index)" :disabled="item.reservationType >= 2 ? true : false" type="number" placeholder="请输入定金金额" min="1">
								<template #addonAfter> 元 </template>
							</a-input>
						</a-form-model-item>
						<a-form-model-item :rules="{required: true, validator: (rule, value, callback) => callback()}" label="支付方式" :key="`deposit-method-${index}`">
							<a-select v-model="item.pay_type" :disabled="item.reservationType >= 2 ? true : false" placeholder="请选择支付方式" :options="reservationType"></a-select>
						</a-form-model-item>
						<a-form-model-item ref="payImage" label="支付凭证" :key="`deposit-receipt-${index}`">
							<image-uploader v-model="item.pay_image" :disabled="item.reservationType >= 2 ? true : false" model-type="Arr" :max="1" :showUploadList="false" :multiple="true" @success="$refs.payImage[index].onFieldBlur()" @remove="$refs.payImage[index].onFieldBlur()" />
						</a-form-model-item>
					</template>
				</template>
				<a-form-model-item label="备注" prop="remark.text" :rules="{max: 100, message: '备注最多只能100个字'}">
					<a-textarea v-model="currentOrderForm.remark.text" showCount :max-length="100" />
				</a-form-model-item>
				<a-form-model-item prop="is_private" label="私密订单">
					<div class="=">
						<a-switch default-checked v-model="currentOrderForm.is_private" />
						<a-tooltip placement="right" :getPopupContainer="trigger => trigger.parentNode">
							<template slot="title">
								<span> 开启私密预订后：该订单中的手机号不会记录为客户，订单信息也将在客户用餐次日自动清除，不会留存及统计 </span>
							</template>
							<a-icon class="ml-3" type="question-circle" style="cursor: pointer" />
						</a-tooltip>
					</div>
				</a-form-model-item>
			</a-form-model>
			<div class="tips" v-if="(currentOrderForm.mini_user_openid == '' && disableCancelChange == 1) || !currentOrderForm.id">
				<span v-if="!isNoteServe">提示：预订成功后会自动发送短信回执和邀请函给顾客。</span>
				<span v-else>提示：选择发送短信后，会自动发送短信到顾客手机，内容为预订信息和就餐邀请函。</span>
			</div>
		</a-modal>
		<!-- 转台 -->
		<a-modal title="转台" v-model="changeRoomVisible" width="680px" :mask-closable="false" :footer="null">
			<a-tabs size="large" v-model="changeRoomCate" @change="getChangeRoomList()">
				<a-tab-pane v-for="item in categoryList" :key="item.id" :tab="item.title">
					<div class="options-bar">
						<div class="options-bar-date">
							<a-button icon="left" class="mr-2" @click="changeRoomOptDate(false)" />
							<a-date-picker :allowClear="false" v-model="changeRoomDate" value-format="YYYY-MM-DD" style="width: calc(100% - 80px)" format="YYYY-MM-DD ddd" :getPopupContainer="trigger => trigger.parentNode" />
							<a-button icon="right" class="ml-2" @click="changeRoomOptDate(true)" />
						</div>
						<div>
							<a-radio-group v-model="changeRoomOrderType" :default-value="changeRoomOrderType">
								<template v-if="holiday && shopConfig.holiday_twice_meal_time && is_holiday_meal_segment.length">
									<template v-for="(itemMealSegment, indexMealSegment) in mealSegment">
										<template v-if="is_holiday_meal_segment[indexMealSegment] && is_holiday_meal_segment[indexMealSegment] > 1">
											<template v-if="itemMealSegment.open">
												<a-dropdown :placement="'bottomCenter'" :trigger="['click']" :key="`dropdown-${indexMealSegment}`">
													<a-menu slot="overlay">
														<a-menu-item @click="onChangeMealSegmentRound($event, indexMealSegment, 1, true)">{{ itemMealSegment.name }}一轮</a-menu-item>
														<a-menu-item @click="onChangeMealSegmentRound($event, indexMealSegment, 2, true)">{{ itemMealSegment.name }}二轮</a-menu-item>
													</a-menu>
													<a-radio-button :key="indexMealSegment" :value="indexMealSegment">{{ itemMealSegment.name }}{{ indexMealSegment === changeRoomOrderType && changeRoomOrderRound >= 2 ? '二轮' : '' }} </a-radio-button>
												</a-dropdown>
											</template>
										</template>
										<template v-else>
											<template>
												<a-radio-button :key="indexMealSegment" @click="onChangeMealSegmentRound($event, indexMealSegment, 1, true)" :value="indexMealSegment" v-if="itemMealSegment.open">
													{{ itemMealSegment.name }}
												</a-radio-button>
											</template>
										</template>
									</template>
								</template>
								<template v-else>
									<template v-if="mealSegment && mealSegment.length">
										<template v-for="(itemMealSegment, indexMealSegment) in mealSegment">
											<a-radio-button :key="indexMealSegment" :value="indexMealSegment" v-if="itemMealSegment.open">
												{{ itemMealSegment.name }}
											</a-radio-button>
										</template>
									</template>
								</template>
							</a-radio-group>
						</div>
					</div>
					<a-table :columns="columns" :data-source="changeRoomList" :loading="changeRoomLoading" :pagination="false" :scroll="{y: 455}" rowKey="id">
						<template #action="record">
							<a-button v-if="!record.isSelf && record.order == '0'" ghost type="primary" @click="onSelectOrderTime(record, '0')"> 确定 </a-button>
							<a-button v-if="!record.isSelf && record.order == '1' && record.order_info.order_date === recordBefore.order_info.order_date && record.order_info.order_type === recordBefore.order_info.order_type" ghost type="primary" :class="'primary_exchange'" @click="onSelectOrderTime(record, '1')"> 调换 </a-button>
						</template>
					</a-table>
				</a-tab-pane>
			</a-tabs>
		</a-modal>
		<!-- 预计到店时间 -->
		<a-modal v-model="showOrderTime" title="预计到店时间" :footer="null">
			<div class="time-list">
				<template v-if="isShowMoreMeal && rangePickerUniqueMeals.length">
					<div
						:class="{
							'time-item': true,
							'time-item-range': true
						}"
						v-for="item in timeList[rangeOrderType]"
						:key="item"
						@click="handleRangeOrderTime(rangeOrderType, item)">
						{{ item }}
					</div>
				</template>
				<template v-else-if="isShowMoreMeal && rangeAllOrderTimes.length && !rangePickerUniqueMeals.length">
					<div
						:class="{
							'time-item': true,
							'time-item-range': true
						}"
						v-for="item in rangeAllOrderTimes"
						:key="item"
						@click="handleRangeOrderTime('rangeAllOrderTimesValue', item)">
						{{ item }}
					</div>
				</template>
				<div
					:class="{
						'time-item': true,
						'time-item-active': currentOrderForm.order_time === item
					}"
					v-for="item in timeList[changeRoomOrderType]"
					:key="item"
					@click="handleOrderTime(item)"
					v-else>
					{{ item }}
				</div>
			</div>
		</a-modal>
		<!-- 取消预订 -->
		<a-modal v-model="cancelOrderVisible" title="取消预订">
			<template #footer>
				<a-button key="back" @click="closeCancelOrder">关闭</a-button>
				<a-button key="submit" type="primary" :loading="cancelLoading" @click="cancelOrder(0)"> 取消预订 </a-button>
				<a-button key="submitAndSend" type="primary" :loading="cancelLoading" @click="cancelOrder(1)"> 取消预订并发送短信 </a-button>
			</template>
			<p>确定要取消该包间的预订吗？</p>
		</a-modal>
		<!-- 余额不足 -->
		<a-modal v-model:visible="showMoneyTip" title="提示">
			<template #footer>
				<a-button key="back" @click="showMoneyTip = false">关闭</a-button>
				<a-button
					key="submit"
					type="primary"
					@click="
						showMoneyTip = false
						getQRCode()
					"
					>立即充值</a-button
				>
			</template>
			<p>您的店铺备用金已耗尽，无法再发送短信，请充值后再使用。</p>
		</a-modal>
		<!-- 高德提示 -->
		<a-modal :title="null" :footer="null" :mask="false" v-model:visible="amapModalVisible" centered="centered">
			<p>{{ amapModalText }}</p>
		</a-modal>
		<!-- 快搜 -->
		<a-modal v-model="isShowQuickSearch" title="快搜" :mask-closable="false" :footer="null" @cancel="onQuickSearch(false)">
			<a-space v-if="quickSearchKeywordList.length > 0" class="name-wrapper">
				<a-button v-for="item in quickSearchKeywordList" :key="item" @click="onChangeSearchName(item)">{{ item }}</a-button>
			</a-space>
			<div class="search-wrapper">
				<div class="search-title">订单快搜</div>
				<div class="search-tips">输入手机号后四位或点击预订人可快速定位订单</div>
				<a-spin v-if="isShowQuickSearchLoading" />
				<div class="search-box" v-else>
					<a-input type="number" :auto-focus="true" v-model:value="quickSearchPhoneValue" :controls="false" @change="onChangeSearchPhone" />
					<div class="search-box-list">
						<template v-for="(item, index) in quickSearchPhoneList">
							<div class="search-item" :key="index">
								<div v-if="item.value">{{ item.value }}</div>
								<div class="search-item_focus" v-if="item.focus && !item.value">|</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</a-modal>
		<!-- 连台连订日期和餐段 -->
		<a-modal :mask-closable="false" :visible.sync="isShowMoreMealPopup" title="请选择日期和餐段" width="700px" @cancel="onHandleMoreMealPopup" @ok="onHandleMoreMealPopup(1)">
			<a-form-model ref="moreMeal" :model="moreMealForm" :label-col="{span: 5}" :wrapper-col="{span: 19}">
				<a-form-model-item
					prop="range"
					label="选择日期范围"
					:rules="{
						required: true,
						message: '请先选择日期'
					}">
					<a-range-picker v-model="moreMealForm.range" :disabled-date="disabledRangePickerDate" @change="onChangeRangePicker" @openChange="resetRangePicker" />
				</a-form-model-item>
				<a-form-model-item
					label="选择餐段"
					:rules="{
						required: true,
						message: '请先选择餐段'
					}">
					<a-radio-group v-model="moreMealForm.type">
						<a-radio value="1"> 全天预订 </a-radio>
						<a-radio value="2"> 指定餐段 </a-radio>
					</a-radio-group>
					<template v-if="moreMealForm.type === '2' && rangeDateArray.length">
						<div v-for="(item, index) in rangeDateArray" :key="index">
							<a-divider orientation="left">{{ item.date }}</a-divider>
							<div class="meal-wrapper">
								<a-checkbox-group v-model="rangePickerSelectedMeals[index]" @change="() => onMealChange(index)">
									<a-checkbox :value="index_meal" v-for="(item_meal, index_meal) in item.meal" :key="index_meal" v-if="item_meal.open">
										{{ item_meal.name }}
									</a-checkbox>
								</a-checkbox-group>
							</div>
						</div>
					</template>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<!-- 上传图片裁剪 -->
		<a-modal v-model:visible="upBanqueImageConfig.show" @cancel="closeModal" title="图片裁剪" width="80%" :bodyStyle="{height: ' 70vh', maxheight: ' 800px', overflow: 'auto'}">
			<vue-cropper ref="cropper" :img="upBanqueImageConfig.url" :outputSize="1" :outputType="'png'" :autoCrop="true" :fixed="true" :fixedNumber="upBanqueImageConfig.fixedNumber" />
			<div slot="footer" class="modal-footer">
				<a-button @click="closeModal">取消</a-button>
				<a-button @click="viewBanqueImage">预览</a-button>
				<a-button type="primary" @click="handleConfirmCrop">确定</a-button>
			</div>
		</a-modal>
		<a-modal v-model:visible="upBanqueImageConfig.viewShow" @cancel="closeViewShowModal" title="预览效果" :bodyStyle="{display: 'flex', justifyContent: 'center'}">
			<div :class="['imageCropperView-box', 'imageCropperView-' + upBanqueImageConfig.key + 'box']">
				<img v-if="upBanqueImageConfig.key === 'menu_img'" class="imageCropperView-menu" src="https://oss.dinggebaojian.com/mini/menu_view.png" alt="" />
				<img v-if="upBanqueImageConfig.key === 'invitation_img'" class="imageCropperView-invitation_img-bg" src="https://oss.dinggebaojian.com/mini/phone_view3.png" alt="" />
				<img v-else class="imageCropperView-bg" :src="'https://oss.dinggebaojian.com/mini/phone_view' + (upBanqueImageConfig.key === 'menu_img' ? 1 : '') + '.png'" alt="" />
				<img :class="'imageCropperView-' + upBanqueImageConfig.key" :src="upBanqueImageConfig.viewImage" alt="" />
			</div>
			<div slot="footer" class="modal-footer">
				<a-button @click="closeViewShowModal">取消</a-button>
				<a-button type="primary" @click="handleConfirmCrop">保存</a-button>
			</div>
		</a-modal>
		<!-- 打印模式 -->
		<a-modal v-model:visible="printShow" centered @cancel="closePrintShowModal" title="请选择打印模式" :footer="null" :bodyStyle="{display: 'flex', justifyContent: 'center'}">
			<a-space size="large">
				<a-button size="large" type="primary" @click="closeOrderA4PrintShowModal"><a-icon type="printer" />A4打印</a-button>
				<a-button size="large" type="primary" @click="orderPrint"><a-icon type="printer" />小票机打印</a-button>
			</a-space>
		</a-modal>
		<!-- A4打印预览 -->
		<a-modal v-model:visible="orderA4PrintShow" width="60%" centered @cancel="closeOrderA4PrintShowModal" title="A4打印预览" :footer="null">
			<div class="orderA4Print_box" ref="orderA4Print">
				<div class="orderA4Print_class" v-if="orderA4PrintList && orderA4PrintList.length">
					<div>请选择需要打印的分类：</div>
					<div class="orderA4Print_checkbox">
						<a-checkbox :indeterminate="indeterminate" :checked="orderA4PrintAll" @change="onCheckAllChange">全选</a-checkbox>
						<a-checkbox-group v-model="orderA4PrintClass" @change="onChangeOrderA4PrintClass" class="orderA4Print_checkbox">
							<template v-for="item in categoryList">
								<a-checkbox v-if="item.id > 0" :key="item.id" :value="item.id">{{ item.title }}</a-checkbox>
							</template>
						</a-checkbox-group>
					</div>
					<a-button size="large" type="primary" @click="onPrint"><a-icon type="printer" />A4打印</a-button>
				</div>
				<div class="orderA4Print_thead">
					<div class="shop_title">{{ $store.state.user.info.shop.title }}</div>
					<div class="orderA4Print_info">
						<div>日期：{{ orderDate }} {{ getWeekDate }}</div>
						<div>餐段：{{ orderTypeName }}{{ orderRound > 1 ? '二轮' : '' }}</div>
						<div>打印时间：{{ orderA4PrintDate }}</div>
					</div>
				</div>
				<div class="orderA4Print_table">
					<template v-for="item in showOrderA4PrintItem">
						<div class="orderA4Print_class_name">{{ item.title }}</div>
						<a-table rowKey="id" tableLayout="fixed" :row-selection="isPrintLoading ? null : {selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" bordered :columns="orderA4PrintColumns" :data-source="showOrderA4PrintList(item.id)" :pagination="false"></a-table>
					</template>
				</div>
			</div>
		</a-modal>
		<!-- 备注图片预览 -->
		<a-modal
			:visible="previewVisible"
			:footer="null"
			@cancel="
				previewVisible = false
				previewImage = []
				previewIndex = 0
			">
			<!-- <img alt="example" style="width: 100%; margin-top: 20px" :src="previewImage" /> -->
			<div v-if="previewImage && previewImage.length">
				<img alt="example" style="width: 100%; margin-top: 20px" :src="previewImage[previewIndex]" />
				<div class="flex justify-between items-center mt-10" v-if="previewImage.length > 1">
					<a-button size="small" @click="previewIndex = (previewIndex - 1 + previewImage.length) % previewImage.length">上一张</a-button>
					<span>{{ previewIndex + 1 }} / {{ previewImage.length }}</span>
					<a-button size="small" @click="previewIndex = (previewIndex + 1) % previewImage.length">下一张</a-button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import {exchangeRoom, changeRoom, sendSms, cancelOrderRoom, editOrderRoom, getRoomList, getRoomListV3, orderRoom, setPassword, settlement, takeUpSeat, clientArrive, getIsHoliday, orderPrint, getOrderChange, setOrderChange, setDeposit, delDeposit, getFutureOrders, getCanOrderRoom, getListByCategory, getRoomOrderInfo} from '@/api/dashboard'
import {getEmployeeList} from '@/api/employee'
import {VueCropper} from 'vue-cropper'
import {getIsBindingList, getWorkMakeMiniQrcode} from '@/api/mobileWorkbench'
import {getRoomCategoryList} from '@/api/roomSetting'
import _ from 'lodash'
import {TreeSelect} from 'ant-design-vue'
import moment from 'moment'
import changeRoomSVG from '@/assets/change-room.svg'
import store from '@/store'
import lgLoading from '@/utils/loading'
import {ossconfig} from '@/api'
import request from '@/utils/request'
import {readDicFn} from '@/utils/utils'
import {phoneReg} from '@/utils/validate'
import BoardInfo from '../../components/boardInfo'
import ImageUploader from '@/components/ImageUploader'

const SHOW_PARENT = TreeSelect.SHOW_PARENT
// 格式化时间数字，不足两位补0
const formatNumber = n => {
	n = n.toString()
	return n[1] ? n : `0${n}`
}

export default {
	name: 'Dashboard',
	mixins: [lgLoading],
	components: {
		BoardInfo,
		ImageUploader,
		VueCropper
	},
	data() {
		return {
			// 定金支付方式
			reservationType: [
				{label: '现金', value: 1},
				{label: '刷卡', value: 2},
				{label: '微信', value: 3},
				{label: '支付宝', value: 4},
				{label: '转账', value: 5},
				{label: '银行', value: 6},
				{label: '其它', value: 7}
			],
			SHOW_PARENT,
			qrLoading: false,
			qrCodeVisible: false,
			qrCode: '',
			isSubmit: false,
			isSetPassword: true,
			isShowMoreMeal: false,
			isShowMoreMealPopup: false,
			isShowRoomList: false,
			passwordForm: {
				password: ''
			},
			// 结算清台
			settlementVisible: false,
			settlementForm: {},
			// 预订
			orderLoading: false,
			orderVisible: false,
			orderTitle: '为顾客订包间',
			currentOrderForm: {
				remark: {
					image: '',
					text: ''
				},
				open_menu: false,
				is_private: false,
				type_version: false
			},
			typeSource: 'classic',
			// 预订定金
			reservationInfo: {
				list: []
			},
			list: [],
			categoryList: [],
			category: undefined,
			categoryForTabs: undefined,
			// 房间状态
			roomStatus: 0,
			today: Date.parse(new Date()) / 1000, // 预订时间
			todayzero: new Date(new Date().toLocaleDateString()).getTime(),
			orderType: null, // 预订类型默认为null, 等待created触发后修改为自定义对应餐段，触发watch，触发调用getList
			orderTypeName: '', // 预订类型中文名
			orderRound: 1,
			orderDate: moment().format('YYYY-MM-DD'),
			orderNoticeCount: 0,
			orderNoticeList: [],
			orderNoticeRepeatCount: 0,
			rangeDateArray: [], // 日期区间对应餐段
			rangePickerStartDate: null, // 存储选择的开始日期
			rangePickerEndDate: null, // 存储选择的结束日期
			rangePickerSelectedMeals: [], // 存储每一天选中的餐段索引
			rangePickerUniqueMeals: [], // 所选餐段的并集
			rangeOrderType: null, // 连台连订餐段
			rangeOrderTimes: ['', '', '', ''], // 预计到店时间
			rangeAllOrderTimes: [], // 连台连订全天预订到店时间列表
			rangeAllOrderTimesValue: '', // 连台连订全天预订到店时间
			rangeMultiRooms: [], // 连台连订房间列表
			phoneReg,
			showOrderTime: false,
			storeMoney: 0,
			timer: null,
			timerNotice: null,
			timerPlayAudio: null,
			timeList: [],
			mustNeedPhone: 0,
			miniAmount: '',
			mealSegment: [
				{
					name: ''
				},
				{
					name: ''
				},
				{
					name: ''
				},
				{
					name: ''
				}
			], //自定义餐段
			moreMealForm: {
				type: '1',
				range: []
			},
			changeRoomSVG,
			changeRoomVisible: false,
			changeRoomLoading: false,
			changeRoomOrderId: '',
			changeRoomRelation: '',
			changeRoomCate: undefined,
			changeRoomDate: moment().format('YYYY-MM-DD'),
			changeRoomOrderRound: 1,
			changeRoomOrderType: 0,
			changeRoomList: [],
			changeRoomSMS: 0,
			columns: [
				{
					title: '包间分类',
					customRender: (text, record) => this.categoryList.find(item => item.id === record.category_id).title
				},
				{
					title: '包间名称',
					dataIndex: 'title'
				},
				{
					title: '容客人数',
					dataIndex: 'number'
				},
				{
					title: '转台',
					key: 'action',
					scopedSlots: {
						customRender: 'action'
					}
				}
			],
			emptyRoomList: [],
			employeeList: [],
			info: {}, // 预订信息
			activityTypes: [
				{
					label: '家宴团圆',
					value: 0
				},
				{
					label: '新春贺喜',
					value: 1
				},
				{
					label: '马到席成',
					value: 2
				},
				{
					label: '年年有余',
					value: 3
				}
			],
			// 邀请函样式
			orderTypes: [
				{
					label: '黑金商务',
					value: 0
				},
				{
					label: '艳红喜庆',
					value: 2
				},
				{
					label: '蓝灰沉稳',
					value: 3
				},
				{
					label: '粉红欢快',
					value: 1
				},
				{
					label: '金色辉煌',
					value: 4
				},
				{
					label: '绿意盎然',
					value: 5
				},
				{
					label: '品牌专属高端质感',
					value: 6
				}
			], //预定类型字典
			orderTypes2: [], // 经典样式2
			isNoteServe: false, //店铺是否配置发送短信功能
			expandedKeys: [], // 控制树的展开状态
			roomTreeData: [], //选择包间
			cancelOrderVisible: false, //取消预订modal
			cancelLoading: false,
			showMoneyTip: false, //余额不足提示
			disableCancelChange: 0,
			shopConfig: {},
			holiday: false, //当前选择的日期是否为节假日
			is_holiday_meal_segment: [], //节假日餐段
			amapModalVisible: false,
			amapModalText: '',
			modalOrderDetail: {
				order_info: {}
			}, // 小卡片预订详情
			isInitCard: true,
			isShowSmallCard: false, // 显示小卡片模式
			isShowOrderDetail: false, // 显示小卡片预订详情弹窗
			isShowQuickSearch: false, // 显示快搜弹窗
			isShowQuickSearchLoading: false, // 显示快搜弹窗loading
			isHideDisabledRoom: false, // 显示禁用包间
			isCompleteChangeRoom: false, // 是否完成转台
			quickSearchKeywordList: [], // 快搜关键字列表
			quickSearchPhoneList: [
				{
					value: '',
					focus: false
				},
				{
					value: '',
					focus: false
				},
				{
					value: '',
					focus: false
				},
				{
					value: '',
					focus: false
				}
			],
			quickSearchPhoneValue: '',
			indexMealSegment: 0,
			roundOpenType: 0, //二轮开启模式
			futureOrdersData: [], //未来订单数据
			banquetLoading: false, //人生36宴loading
			banquetActiveKey: [], //36宴选择
			banquetList: [], //人生36宴列表
			banqueInfo: {
				feast_name: '', //人生36宴名称
				name: '',
				id: 0,
				theme_img: '', //邀请函自定义主题图片
				menu_img: '', //邀请函自定义排菜图片
				invitation_img: '' //邀请函自定义封面图片
			}, //人生36宴详情
			upBanqueImageConfig: {
				//上传图片配置
				show: false,
				url: ''
			},
			selectedRowKeys: [], // 选中的行
			printShow: false, //打印模式弹框
			orderA4PrintShow: false, //A4打印预览
			orderA4PrintList: [], //A4打印数据
			orderA4PrintColumns: [
				{
					title: '餐位名称',
					dataIndex: 'title',
					width: 150,
					align: 'center'
				},
				{
					title: '预订人',
					dataIndex: 'order_info.name',
					width: 150,
					align: 'center'
				},
				{
					title: '性别',
					dataIndex: 'order_info.sex',
					align: 'center',
					customRender: (item, record) => (item === 1 ? '先生' : item === 2 ? '女士' : '')
				},
				{
					title: '手机号',
					dataIndex: 'order_info.phone',
					width: 150,
					align: 'center'
				},
				{
					title: '预订人数',
					dataIndex: 'order_info.number',
					align: 'center'
				},
				{
					title: '到店时间',
					dataIndex: 'order_info.order_time',
					align: 'center'
				},
				{
					title: '备注',
					dataIndex: 'order_info.remark.text',
					width: 200,
					align: 'center'
				},
				{
					title: '下单人',
					dataIndex: 'order_info.with_mini_bind_user.nickname',
					align: 'center',
					customRender: text => {
						return text ? text : '前台'
					}
				}
			],
			orderA4PrintDate: '',
			orderA4PrintClass: [0],
			indeterminate: true,
			orderA4PrintAll: true,
			isPrintLoading: false,
			previewVisible: false,
			previewImage: [],
			previewIndex: 0,
			customOrderTime: null
		}
	},
	async created() {
		await this.getStoreInfo() // 获取店铺信息
		this.openTimeChange()
	},
	mounted() {
		this.isNoteServe = true // 默认全部发送短信
	},
	beforeDestroy() {
		this.stopLoop()
		this.stopLoopNotice()
	},
	destroyed() {
		this.stopLoop()
		this.stopLoopNotice()
	},
	watch: {
		banquetActiveKey(key) {},
		/* 监听查询条件 */
		roomStatus() {
			if (this.roomStatus !== 3) {
				this.quickSearchPhoneValue = ''
				this.quickSearchPhoneList = [
					{
						value: '',
						focus: false
					},
					{
						value: '',
						focus: false
					},
					{
						value: '',
						focus: false
					},
					{
						value: '',
						focus: false
					}
				]
				this.quickSearchKeywordList = []
				this.getList()
			}
		},
		roundOpenType(value) {
			this.checkRoundOpenType(this.orderDate)
		},
		orderType() {
			this.getList()
		},
		orderDate() {
			if (!this.isCompleteChangeRoom) {
				this.orderRound = 1
				this.orderType = this.handleCurrentMealSegment(null, this.mealSegment)
				this.checkRoundOpenType(this.orderDate)
				this.getList()
				this.isCompleteChangeRoom = false
			}
			this.openTimeChange()
		},
		changeRoomDate() {
			this.changeRoomOrderRound = 1
			this.changeRoomOrderType = this.handleCurrentMealSegment(null, this.mealSegment)
			this.checkRoundOpenType(this.changeRoomDate)
			this.getChangeRoomList()
		},
		changeRoomOrderType() {
			this.getChangeRoomList()
		},
		isShowSmallCard() {
			if (!this.isInitCard) this.getList()
		},
		isShowMoreMeal(value) {
			if (!value) {
				this.rangeDateArray = []
				this.rangePickerStartDate = null
				this.rangePickerEndDate = null
				this.rangePickerSelectedMeals = []
				this.rangePickerUniqueMeals = []
				this.rangeOrderType = null
				this.rangeOrderTimes = ['', '', '', '']
				this.moreMealForm = {
					type: '1',
					range: []
				}
				this.currentOrderForm.room_id = []

				this.resetAndReloadTreeData()
			} else {
				if (!this.rangeDateArray.length && this.currentOrderForm.room_id.length) {
					this.$message.warning('餐段发生变化，请重新选择包间')

					this.currentOrderForm.room_id = []
					this.resetAndReloadTreeData()
				}
			}
		}
	},
	computed: {
		getWeekDate() {
			const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
			const now = new Date(this.orderDate)
			return week[now.getDay()]
		},
		isShowTakeUp() {
			return new Date(this.orderDate).getTime() >= new Date(this.getToday()).getTime()
		},
		hasCorpId() {
			return this.$store.state.user.info.shop && this.$store.state.user.info.shop.corpid
		},
		// 判断是否选中分类显示 过滤 打印
		showOrderA4PrintItem() {
			let categoryList = JSON.parse(JSON.stringify(this.categoryList))
			let orderA4PrintClass = this.orderA4PrintClass
			categoryList = categoryList.filter(item => {
				return item.title !== '全部' && orderA4PrintClass.find(items => items === item.id)
			})
			// 打印中隐藏
			if (this.isPrintLoading && this.selectedRowKeys) {
				let orderA4PrintList = this.orderA4PrintList
				let list = orderA4PrintList.filter(item => {
					return this.selectedRowKeys.find(key => key === item.id)
				})
				categoryList = categoryList.filter(item => {
					return list.find(items => items.category_id === item.id)
				})
			}
			return categoryList
		},
		// 显示对应分类餐位 打印
		showOrderA4PrintList() {
			return function (id) {
				let orderA4PrintClass = this.orderA4PrintList
				let list = orderA4PrintClass.filter(item => {
					return item.category_id === id
				})
				// 打印中隐藏
				if (this.isPrintLoading && this.selectedRowKeys) {
					list = list.filter(item => {
						return this.selectedRowKeys.find(key => key === item.id)
					})
				}
				return list
			}
		},
		typeActivity: {
			get() {
				const v = this.currentOrderForm.type
				const values = this.activityTypes.map(i => i.value)
				return this.typeSource === 'activity' && values.includes(v) ? v : null
			},
			set(val) {
				this.typeSource = 'activity'
				this.currentOrderForm.type = val
			}
		},
		typeClassic: {
			get() {
				const v = this.currentOrderForm.type
				const values = this.orderTypes.map(i => i.value)
				return this.typeSource === 'classic' && values.includes(v) ? v : null
			},
			set(val) {
				this.typeSource = 'classic'
				this.currentOrderForm.type = val
			}
		}
	},
	methods: {
		// 选择行
		onSelectChange(selectedRowKeys, selectedRows) {
			this.selectedRowKeys = selectedRowKeys
		},
		// 全选
		onCheckAllChange(e) {
			let categoryList = JSON.parse(JSON.stringify(this.categoryList))
			categoryList = categoryList.filter(item => {
				return item.title !== '全部'
			})
			Object.assign(this, {
				orderA4PrintClass: e.target.checked ? categoryList.map(item => item.id) : [],
				indeterminate: false,
				orderA4PrintAll: e.target.checked
			})
		},
		// 选择包间打印
		onChangeOrderA4PrintClass(orderA4PrintClass) {
			let categoryList = JSON.parse(JSON.stringify(this.categoryList))
			categoryList = categoryList.filter(item => {
				return item.title !== '全部'
			})
			this.orderA4PrintClass = orderA4PrintClass
			this.indeterminate = !!orderA4PrintClass.length && orderA4PrintClass.length < categoryList.length
			this.orderA4PrintAll = orderA4PrintClass.length === categoryList.length
		},
		// 打印
		onPrint() {
			this.isPrintLoading = true
			this.$nextTick(() => {
				// 创建打印容器
				const printContainer = document.createElement('div')
				printContainer.className = 'print-container'
				// return
				// 克隆模态框内容
				if (this.$refs.orderA4Print) {
					const modalContent = this.$refs.orderA4Print.cloneNode(true)
					// 添加到打印容器
					printContainer.appendChild(modalContent)
					// 添加到body
					document.body.appendChild(printContainer)
					// 创建打印样式
					const style = document.createElement('style')
					style.textContent = `
						@media print {
							/* 重置页面样式 */
									body {
										margin: 0;
										padding: 0;
										width: 100%;
										zoom: 60%;
									}

									.print-container {
										display: block;
										margin-right:0.5cm;
									}
									body > *:not(.print-container),.orderA4Print_box .orderA4Print_class{
										display: none;
									}
									@page {
										size: A4;
										margin: 0.5cm 0 0.5cm 0.5cm;
									}
									.ant-table-wrapper{
										margin-top:10px;
									}
									.ant-table table{
										border-radius:0!important;
									}
									.ant-table-bordered .ant-table-header > table,.ant-table-bordered .ant-table-body > table,.ant-table-bordered .ant-table-fixed-left table,.ant-table-bordered .ant-table-fixed-right table {
										border-radius:0!important;
										border:none!important;
									}
									.ant-table-bordered .ant-table-thead > tr > th{
										border-top: 1.5px solid #000!important;
										border-bottom: 1.5px solid #000!important;
										border-right:none!important;
										border-left: 1.5px solid #000 !important; /* 补充左边框，避免遗漏 */
										padding: 10px 0;
									}
									.ant-table-bordered .ant-table-thead > tr:first-child > th:first-child{
										border-radius:0!important;
									}
									.ant-table-thead > tr:first-child > th:last-child{
										border-radius:0!important;
										border-right: 1.5px solid #000!important;
									}
									.ant-table-bordered .ant-table-tbody > tr > td{
										border-bottom: 1.5px solid #000!important;
										border-left: 1.5px solid #000 !important; /* 补充左边框，避免遗漏 */
										text-align: center;
										border-right:none!important;
										padding: 10px 0;
									}
									.ant-table-bordered .ant-table-tbody > tr > td:last-child{
										border-right: 1.5px solid #000!important;
									}
								}
								`
					document.head.appendChild(style)
					// 执行打印
					window.print()
					// 打印完成后清理
					setTimeout(() => {
						document.body.removeChild(printContainer)
						document.head.removeChild(style)
						this.isPrintLoading = false
						this.subLoading()
					}, 100)
				}
			})
		},
		// A4打印模式弹框
		async closeOrderA4PrintShowModal() {
			let orderA4PrintShow = !this.orderA4PrintShow
			this.printShow = false
			if (orderA4PrintShow) {
				//开启查询包间
				this.addLoading()
				let params = {
					order_date: this.orderDate,
					order_round: this.orderRound,
					order_type: this.orderType,
					status: 0
				}
				let {code, data} = await getRoomListV3(params)
				if (code === 0) {
					let orderA4PrintList = data.filter(item => item.order_info && item.order_info.id && !item.order_info.hold_seat) || []
					let selectedRowKeys = []
					orderA4PrintList = orderA4PrintList.map(item => {
						item.order_info.phone = item.order_info.phone ? item.order_info.phone.substring(0, 3) + '****' + item.order_info.phone.slice(item.order_info.phone.length - 4) : ''
						if (item.order_info && item.order_info.relation) {
							item.title = `${item.order_info.alias}* ${item.title}`
						}
						selectedRowKeys.push(item.id)
						return item
					})
					// 查询当日的连台订单
					this.orderA4PrintList = orderA4PrintList
					// 默认全选
					let categoryList = JSON.parse(JSON.stringify(this.categoryList))
					categoryList = categoryList.filter(item => {
						return item.title !== '全部'
					})
					this.selectedRowKeys = selectedRowKeys
					this.indeterminate = false
					this.orderA4PrintClass = categoryList.map(item => item.id)
					this.orderA4PrintShow = orderA4PrintShow
					this.orderA4PrintDate = moment().format('YYYY-MM-DD HH:mm:ss')
				}
			} else {
				this.orderA4PrintShow = orderA4PrintShow
			}
		},
		// 打印模式弹框
		closePrintShowModal() {
			this.printShow = !this.printShow
		},
		// 初始人生36
		initBanqueInfo() {
			this.banquetActiveKey = []
			this.banquetList = []
			this.banqueInfo = {
				feast_name: '', //人生36宴名称
				name: '',
				id: 0,
				theme_img: '', //邀请函自定义主题图片
				menu_img: '', //邀请函自定义排菜图片
				bg_img: '',
				invitation_img: '', //邀请函自定义封面图片
				music_url: '' //背景音乐
			}
			this.upBanqueImageConfig = {
				//上传图片配置
				show: false,
				url: ''
			}
		},
		/**
		 * @description: 渲染日期
		 * @return {*}
		 */
		openTimeChange() {
			const time = new Date(this.orderDate)
			const year = time.getFullYear()
			const month = time.getMonth() + 1
			getFutureOrders({
				year,
				month
			}).then(res => {
				if (res.code === 0) {
					this.futureOrdersData = res.data
				}
			})
		},
		isTargetDate(current) {
			const dateStr = current.format('YYYY-MM-DD')
			return this.futureOrdersData[dateStr] !== undefined
		},
		getTargetDateCount(current) {
			const dateStr = current.format('YYYY-MM-DD')
			return this.futureOrdersData[dateStr].count || ''
		},
		// 小卡片详情状态
		handleModalOrderStatus(target = {}, type = 'class') {
			if (JSON.stringify(target) === '{}') return

			const {
				order_info: {client_arrive, confirm, hold_seat, isTimeout}
			} = target
			// 客已到/已占座
			if (client_arrive === 1) return {class: '05', name: '客已到'}[type]
			else if (hold_seat === 1) return {class: '05', name: '已占座'}[type]
			else if (client_arrive !== 1) {
				// 已到点
				if (isTimeout) return {class: '02', name: '已到点'}[type]
				// 已确认
				else if (confirm === 1 || confirm === 4) return {class: '04', name: '已确认'}[type]
				// 已预订
				else return {class: '01', name: '已预订'}[type]
			}
		},
		/**
		 * @description: 格式化预订人姓名
		 * @return {*}
		 */
		formatUserInfo(order, type = 'name') {
			if (!order || JSON.stringify(order) === '{}') return

			if (type === 'phone') {
				return order.phone ? `${order.phone.slice(0, 3)}****${order.phone.slice(-4)}` : '无'
			}

			const SEX_MAP = {
				0: {
					name: '',
					sex: '未知'
				},
				1: {
					name: '先生',
					sex: '男'
				},
				2: {
					name: '女士',
					sex: '女'
				}
			}

			return type === 'name' ? order.name + SEX_MAP[order.sex][type] : SEX_MAP[order.sex][type]
		},
		/**
		 * @description: 格式化邀请函样式
		 * @return {*}
		 */
		formatInvitationType(orderInfo = {}) {
			if (this.orderTypes.length <= 0 || orderInfo.type === '') return

			let target
			if (orderInfo.type < 7) {
				let targetTypes = orderInfo.type_version === 2 ? this.activityTypes : this.orderTypes
				target = targetTypes.find(item => item.value === orderInfo.type)
			} else {
				target = {
					label: orderInfo?.order_theme_info?.feast_name
				}
			}

			return target.label + (orderInfo.type_version === 1 ? '（样式2）' : '')
		},
		// 判断二轮开启模式
		checkRoundOpenType(orderDate) {
			let roundOpenType = this.roundOpenType
			if (roundOpenType === 1) {
				this.isHoliday(orderDate)
			} else {
				//长期 全部为二轮
				this.holiday = true
				this.is_holiday_meal_segment = [2, 2, 2, 2]
				this.shopConfig.holiday_twice_meal_time = 1
			}
		},
		// 删除一笔定金
		onDeleteReservationInfo(index) {
			let item = this.reservationInfo.list[index]
			const del = () => {
				this.reservationInfo.list.splice(index, 1)
			}
			this.$confirm({
				title: '请确认',
				content: '是否确认删除当前定金？',
				okText: '是',
				cancelText: '否',
				centered: true,
				onOk: async () => {
					if (item.receipt_number) {
						//属于提交过的定金
						await delDeposit({receipt_number: item.receipt_number}) //定金
						del()
						this.getList()
					} else {
						del()
					}
				},
				onCancel: () => {
					this.reservationInfo.status = true
				}
			})
		},
		// 新增一笔定金
		addReservation() {
			this.reservationInfo.list.push({
				reservationType: 0, //0未下定金 1已下定金 2已下定金并且已核销 3已打印
				pay_money: '', //支付金额
				pay_type: undefined, //支付方式
				pay_image: [], //支付凭证
				status: 1
			})
		},
		// 支付金额控制位数
		payMoneyChange(index) {
			let item = this.reservationInfo.list[index]
			let value = item.pay_money.toString()
			if (value.length > 7) {
				value = value.slice(0, 7)
				this.reservationInfo.list[index].pay_money = parseFloat(value)
			}
		},
		initReservationInfo() {
			this.reservationInfo = {
				list: []
			}
		},
		showAMapTip(event, type, data) {
			this.amapModalVisible = true
			this.amapModalText = ['', '顾客已通过高德改期到店', `顾客正导航到店中预计到达时间 ${data?.latestEta || ''}`][type]
		},
		visibleCancel() {
			this.qrCodeVisible = false
			this.qrLoading = false
		},
		getTagClassName(tagName) {
			const index = {散客: 1, 普通: 2, 重要: 3, 核心: 4}[tagName]
			return `tag-${index}`
		},
		/**
		 * @description: 点击重置请求二维码图片，打开二维码
		 * @return {*}
		 * @param {*} refresh
		 */
		getQRCode(refresh = 0) {
			this.qrLoading = true
			// 拼装入参
			const params = {
				page: 'work_pages/pages/recharge/recharge',
				params: `shop_id=${this.$store.state.user.info.shop.id}`,
				width: 200
			}
			this.qrCodeVisible = true
			// 通过公共二维码获取接口获取二维码图片链接
			getWorkMakeMiniQrcode(params).then(res => {
				if (res.code === 0) {
					this.qrCode = res.data
					this.qrLoading = false
					if (refresh === 1) {
						this.$message.success('刷新成功！')
					}
				}
			})
		},
		isAm() {
			const date = new Date()
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDate()
			const pmTime = new Date(`${[year, month, day].map(formatNumber).join('-')} 14:30`).getTime()
			const nowTime = new Date().getTime()
			return nowTime > pmTime
		},
		getToday() {
			return moment(new Date()).format('YYYY-MM-DD')
		},
		setMiniAmount(templateType = '') {
			if (templateType / 1 === 3) {
				this.miniAmount = 50
			} else if (templateType / 1 === 2) {
				this.miniAmount = 30
			} else if (templateType / 1 === 1) {
				this.miniAmount = 10
			}
		},
		/**
		 * @description: 获取门店登录信息
		 * @return {*}
		 */
		getStoreInfo() {
			this.addLoading()
			// 获取本地是否已设置过设置密码
			let isInitPassword = this.$store.state.user.info.shop?.password ?? false
			this.$store
				.dispatch('user/GetInfo')
				.then(() => {
					let {info = {}} = this.$store.state.user
					if (isInitPassword) {
						info.shop.password = true
					}
					if (!isInitPassword && info.shop.password) {
						isInitPassword = true
					}
					// 配置赋值
					this.isSetPassword = isInitPassword
					this.changeRoomSMS = info?.shop?.to_sms_config?.sms_config?.change_room_sms
					this.disableCancelChange = info?.shop?.to_sms_config?.sms_config?.disable_cancel_change ?? 0
					this.mealSegment = info?.shop?.to_sms_config?.sms_config?.meal_segment ?? []
					if (info?.shop?.to_sms_config?.sms_config) {
						//当值为空时，默认开启
						info.shop.to_sms_config.sms_config.show_order_dishes = info?.shop?.to_sms_config?.sms_config.show_order_dishes === 0 ? 0 : 1
					}
					this.roundOpenType = info?.shop?.to_sms_config?.sms_config?.roundOpenType ?? 1
					this.mustNeedPhone = info?.shop?.to_sms_config?.sms_config?.must_need_phone ?? 0
					this.shopConfig = info?.shop?.to_sms_config?.sms_config
					this.storeMoney = info?.money
					// 是否开启隐藏禁用包间
					this.isHideDisabledRoom = info?.shop?.to_sms_config?.sms_config?.staple_hide_disabled_room === 1 ? true : false
					this.orderType = this.handleCurrentMealSegment(null, this.mealSegment)
					// 判断当前是否为小卡片模式
					this.isShowSmallCard = localStorage.getItem('showSmallCard') || null
					if (this.isShowSmallCard === null) {
						this.isShowSmallCard = info?.shop?.to_sms_config?.sms_config?.staple_show_small_card === 1 ? true : false
					} else {
						this.isShowSmallCard = JSON.parse(this.isShowSmallCard)
					}

					this.setMiniAmount(info?.shop?.to_sms_config?.sms_config?.template_type)
					this.handleMealTimeList()
					this.getCategory() // 获取分类列表
					this.getEmployees() // 获取员工列表
				})
				.finally(() => {
					this.subLoading()
				})
		},
		/**
		 * @description: 一分钟轮询一次接口， 刷新请求列表
		 * @return {*}
		 */
		async startLoop() {
			this.stopLoop()

			let params = {
				category_id: this.category,
				order_date: this.orderDate,
				order_round: this.orderRound,
				order_type: this.orderType,
				status: this.roomStatus
			}
			// 全部分类/小卡片模式剔除分类ID
			if (params.category_id === 0 || this.isShowSmallCard) delete params.category_id
			// 快搜功能
			if (this.quickSearchPhoneValue && this.quickSearchPhoneValue.length === 4) {
				params.keyword_phone = this.quickSearchPhoneValue
				params.status = 1
			}
			// V3接口获取包间列表
			let {code, data} = await getRoomListV3(params)

			if (code === 0) {
				this.list = data.map(item => {
					if (item.order === 1) {
						const nowTime = new Date().getTime()
						const orderTime = new Date(`${item.order_info.order_date} ${item.order_info.order_time}`).getTime()

						this.$set(item.order_info, 'isTimeout', nowTime > orderTime)
					}

					if (item.order_info && item.order_info.relation && !item.isEven && !this.isShowSmallCard) {
						item.isEven = 0
						data.map(info => {
							if (info.order_info?.relation === item.order_info?.relation) {
								item.isEven = 1
							}
						})
					}

					return item
				})

				// 过滤禁用且不显示的包间
				this.list = this.list.filter(item => {
					return item.status === 1 || (item.status === 0 && !this.isHideDisabledRoom)
				})

				if (this.isShowSmallCard) this.list = await this.handleSmallModelRoomList(this.list)

				this.timer = setTimeout(this.startLoop, 60 * 1000)
			}
		},
		/**
		 * @description: 停止轮询
		 * @return {*}
		 */
		stopLoop: function () {
			if (this.timer) {
				clearInterval(this.timer)
				this.timer = null
			}
		},
		/**
		 * @description: 30秒轮询一次接口，刷新请求订单通知
		 * @return {*}
		 */
		async startLoopNotice() {
			this.stopLoopNotice()

			// 获取订单更新消息推送
			let {code: code_change, data: data_change} = await getOrderChange()

			if (code_change === 0 && data_change.notice.length) {
				// const {action_type, id} = data_change.notice[0]
				// const messageData = {
				// 	1: '新的订单',
				// 	6: '订单已修改',
				// 	7: '订单已转台',
				// 	9: '订单已取消'
				// }

				// // 弹窗提示
				// if (action_type === 9) {
				// 	this.$message.error(`您有${messageData[action_type]}`)
				// } else {
				// 	this.$message.success(`您有${messageData[action_type]}`)
				// }

				// // 通知安卓播放音频
				// if (window.android) {
				// 	// 前面有正在播放的音频，先清除
				// 	if (this.timerPlayAudio) {
				// 		this.orderNoticeRepeatCount = 0
				// 		clearTimeout(this.timerPlayAudio)
				// 		this.timerPlayAudio = null
				// 	}
				// 	// 循环播放三次，每次持续3秒
				// 	this.timerPlayAudio = setTimeout(() => {
				// 		if (this.orderNoticeRepeatCount < 3) {
				// 			window.android.playAudio(action_type)
				// 			this.orderNoticeRepeatCount++
				// 		} else {
				// 			this.orderNoticeRepeatCount = 0
				// 			clearTimeout(this.timerPlayAudio)
				// 			this.timerPlayAudio = null
				// 		}
				// 	}, 3000)
				// }
				this.orderNoticeCount = data_change.notice.length
				// 更新变更记录角标
				// this.orderNoticeCount = this.orderNoticeCount + data_change.notice.length
				// 更新变更对应订单数
				data_change.notice.forEach(item => {
					if (item.order_id) this.orderNoticeList.push(item.order_id)
				})

				// 更新订单通知状态
				// 1创建订单;
				// 6修改订单;
				// 7转台订单;
				// 9取消订单;
				// const {code: code_update} = await setOrderChange({id})
				// if (code_update === 0) {
				// 	// 刷新页面
				// 	this.getList()
				// }
				// await setOrderChange({id})
			}

			this.timerNotice = setTimeout(this.startLoopNotice, 30 * 1000)
		},
		/**
		 * @description: 停止轮询
		 * @return {*}
		 */
		stopLoopNotice: function () {
			if (this.timerNotice) {
				clearInterval(this.timerNotice)
				this.timerNotice = null
			}
		},
		/**
		 * @description: 获取包间tabs数据(如：大厅\散台)，动态插入全部类目
		 * @return {*}
		 */
		async getCategory() {
			let {code, data} = await getRoomCategoryList()

			if (code === 0) {
				this.categoryList = data

				// 根据设置是否显示全部
				let isShowAllRooms = this.shopConfig?.staple_show_all_rooms ?? false
				if (isShowAllRooms) {
					this.categoryList.splice(0, 0, {
						id: 0,
						shop_id: 0,
						sort: 0,
						title: '全部',
						type_id: 0
					})
				}

				// 赋值
				this.category = this.categoryList[0].id
				this.changeRoomCate = this.categoryList[0].id
			}
		},
		/**
		 * @description: 切换包间列表
		 * @return {*}
		 */
		async getChangeRoomList() {
			this.changeRoomLoading = true
			this.changeRoomList = []

			let params = {
				category_id: this.changeRoomCate,
				order_date: this.changeRoomDate,
				order_round: this.changeRoomOrderRound,
				order_type: this.changeRoomOrderType,
				status: 0
			}
			// 全部分类剔除分类ID
			if (params.category_id === 0) delete params.category_id
			// V3接口获取包间列表
			let {code, data} = await getRoomListV3(params)

			if (code === 0) {
				this.changeRoomList = data.map(item => {
					item.isSelf = !!((item?.order_info?.relation && this.changeRoomRelation && item?.order_info?.relation === this.changeRoomRelation) || item?.order_info?.id === this.changeRoomOrderId || item?.order_info?.client_arrive === 1)
					return item
				})
			}

			this.changeRoomLoading = false
		},
		/**
		 * @description: 获取包间列表
		 * @return {*}
		 */
		async getList() {
			this.addLoading()
			// 餐段二轮名称
			this.orderTypeName = this.mealSegment[this.orderType].name
			let params = {
				category_id: this.category,
				order_date: this.orderDate,
				order_round: this.orderRound,
				order_type: this.orderType,
				status: this.roomStatus
			}
			// 全部分类/小卡片模式剔除分类ID
			if (params.category_id === 0 || this.isShowSmallCard) delete params.category_id
			// 快搜功能(包括关键字和手机号后四位)
			if (this.quickSearchPhoneValue) {
				params.keyword_phone = this.quickSearchPhoneValue
				params.status = 1
			}
			// V3接口获取包间列表
			let {code, data} = await getRoomListV3(params)

			if (code === 0) {
				// 判断是否已到点
				this.list = data.map(item => {
					if (item.order === 1) {
						const nowTime = new Date().getTime()
						const orderTime = new Date(`${item.order_info.order_date} ${item.order_info.order_time}`).getTime()

						this.$set(item.order_info, 'isTimeout', nowTime > orderTime)

						// 兼容原来单张备注图片
						if (item.order_info.remark.image) {
							if (typeof item.order_info.remark.image === 'string') {
								item.order_info.remark.image = [item.order_info.remark.image]
							}
						}
					}

					return item
				})

				// 过滤禁用且不显示的包间
				this.list = this.list.filter(item => {
					return item.status === 1 || (item.status === 0 && !this.isHideDisabledRoom)
				})

				if (this.isShowSmallCard) this.list = await this.handleSmallModelRoomList(this.list)
			}

			this.subLoading()

			setTimeout(async () => {
				await this.startLoop()
				await this.startLoopNotice()
				await this.subLoading()
			}, 60 * 1000)
		},
		/**
		 * @description: 根据餐段配置来筛选当前餐段
		 * @return {*}
		 * @param {*} list 餐段配置列表
		 */
		handleCurrentMealSegment(targetTime, targetList = []) {
			// 格式化时间戳
			const formatGetTime = (formatTime, isFullDate = false) => {
				return new Date(isFullDate ? formatTime : `${[year, month, day].map(formatNumber).join('/')} ${formatTime}`).getTime()
			}
			// 获取当前时间
			const date = this.getBeijingTime()
			const year = date.getUTCFullYear()
			const month = date.getUTCMonth() + 1
			const day = date.getUTCDate()
			const currentTime = targetTime ? formatGetTime(targetTime) : formatGetTime(date, true) //格式化传入时间戳
			// 自定义餐段开始/结束时间和餐段类型
			let startTime = 0,
				endTime = 0,
				mealType = 1
			// 存在自定义餐段
			if (targetList && targetList.length > 0) {
				// 如果当前时间不在全部餐段时间内，则默认为第一个开启的餐段
				mealType = targetList.findIndex(item => item.open)
				targetList.forEach((item, index) => {
					if (item.open) {
						// 上一个餐段结束时间到下一个餐段结束时间，中间的区间均属于下一餐段范围
						endTime = formatGetTime(item.time_ranger[1])
						if (startTime < currentTime && currentTime <= endTime) {
							mealType = index
						}
					}

					startTime = formatGetTime(item.time_ranger[1])
				})
			}

			return mealType
		},
		/**
		 * @description: 处理小卡片列表
		 * @return {*}
		 * @param {*} roomList
		 */
		async handleSmallModelRoomList(roomList) {
			if (this.categoryList.length < 1) return

			let result = new Array()
			if (roomList.length) {
				// 对列表进行分组
				result = roomList.reduce((acc, cur) => {
					// 在已有分组中查找对应的分类id
					let group = acc.find(item => item.categoryId === cur.category_id)
					if (!group) {
						let categoryName = this.categoryList.find(item => item.id === cur.category_id)?.title
						// 如果不存在对应的分组，创建一个新的
						group = {categoryId: cur.category_id, categoryName, roomList: []}
						acc.push(group)
					}
					// 添加当前的 value 到对应的分组
					group.roomList.push(cur)

					return acc
				}, [])

				// 如果已开启了全部分类，则头部添加全部分类及内容
				if (this.categoryList[0].id === 0) {
					result.unshift({
						categoryId: 0,
						categoryName: '全部',
						roomList: [...roomList]
					})
				}
			}

			// 创建排序映射：根据分类列表的ID顺序生成索引
			let orderMap = {}
			this.categoryList.forEach((item, index) => {
				orderMap[item.id] = index
			})

			// 对小卡片包间列表按映射排序
			let sortedRoomList = result.sort((a, b) => {
				return orderMap[a.categoryId] - orderMap[b.categoryId]
			})

			return sortedRoomList
		},

		/**
		 * @description: 获取当前北京时间
		 * @return {*}
		 */
		getBeijingTime() {
			// 获得当前运行环境时间
			let d = new Date()
			let currentDate = new Date()
			let tmpHours = currentDate.getHours()
			let time_zone = -d.getTimezoneOffset() / 60 //算的时区
			// 计算范围
			if (time_zone < 0) {
				time_zone = Math.abs(time_zone) + 8
				currentDate.setHours(tmpHours + time_zone)
			} else {
				time_zone -= 8
				currentDate.setHours(tmpHours - time_zone)
			}

			return currentDate
		},
		/**
		 * @description: 处理餐段时间区间
		 * @return {*}
		 */
		handleMealTimeList() {
			const filterTimeRange = timeRange => {
				let timeList = []
				let startTime = new Date(`${this.orderDate} ${timeRange[0]}`)
				let endTime = new Date(`${this.orderDate} ${timeRange[1]}`)
				let currentTime = startTime.getTime()
				while (currentTime <= endTime.getTime()) {
					let tempTime = new Date(currentTime)
					timeList.push(tempTime.toTimeString().substring(0, 5)) // 获取时间的HH:mm格式
					currentTime += 30 * 60 * 1000 // 增加30分钟
				}
				return timeList
			}
			// 当前日期
			let tempTimeList = {}
			this.mealSegment.forEach((item, index) => {
				tempTimeList[index] = filterTimeRange(item.time_ranger)
				if (tempTimeList[index][tempTimeList[index].length - 1] !== '待定') {
					tempTimeList[index].push('待定')
				}
			})
			// 增加二轮时间
			tempTimeList[4] = tempTimeList[1] //午餐二轮
			tempTimeList[5] = tempTimeList[2] //晚餐二轮
			this.timeList = tempTimeList
		},
		/**
		 * @description: 保存密码
		 * @return {*}
		 */
		savePassword() {
			this.$refs.password
				.validate()
				.then(() => {
					this.$confirm({
						content: '确定保存吗？',
						title: '保存密码',
						onOk: () => {
							setPassword(this.passwordForm).then(res => {
								if (res.code === 0) {
									this.$message.success('设置成功！')
									// 构造相同的用户信息obj再存到storage
									const initInfo = {
										auth_type: 'work_admin',
										shop: _.cloneDeep(res.data),
										user: {
											phone: res.data.phone
										}
									}
									store.commit('user/SET_INFO', initInfo)
									this.isSetPassword = this.$store.state.user.info.shop.password
								}
							})
						}
					})
				})
				.catch(err => err)
		},

		/**
		 * @description: 关闭预订下单/修改订单弹窗
		 * @return {*}
		 */
		onCancelOrderRoom() {
			this.$refs.order.clearValidate()
			this.orderVisible = false
			// 小卡片模式弹窗判断
			if (this.modalOrderDetail && this.modalOrderDetail.id) {
				this.isShowOrderDetail = true
			}

			this.$nextTick(() => {
				setTimeout(() => {
					this.currentOrderForm = {
						remark: {
							image: '',
							text: ''
						},
						type_version: false
					}
					this.initReservationInfo()
					this.roomTreeData = []
					this.isShowMoreMeal = false
					this.isShowRoomList = false
					this.customOrderTime = null
				}, 500)
			})
		},

		/**
		 * 预订包间-空闲
		 * */
		async orderRoom(item) {
			this.initBanqueInfo()

			if (item) {
				if (item.status === 0) {
					this.$message.error({
						content: '当前餐位已被禁用',
						key: 'statusRoom'
					})
					return
				}
				if (item.order === 1) return
				this.currentOrderForm = {
					room_id: item.id,
					title: item.title,
					sex: 1,
					type: this.$store.state.user?.info?.shop?.default_order_theme ?? 0,
					remark: {
						image: '',
						text: ''
					},
					unit: '人',
					order_time: this.timeList[this.orderType][0],
					type_version: item.type_version || this.$store.state.user.info.shop.default_order_theme_v === 1 ? true : false
				}
				this.orderTypes[this.orderTypes.length - 1].disabled = false
			} else {
				let type = this.$store.state.user?.info?.shop?.default_order_theme ?? 0
				if (type === 6) {
					type = 0
				}
				this.currentOrderForm = {
					room_id: [],
					sex: 1,
					type,
					type_version: false,
					remark: {
						image: '',
						text: ''
					},
					unit: '人'
				}
				// this.orderTypes[this.orderTypes.length - 1].disabled = true
				this.roomTreeData = []
				this.roomTreeData = this.categoryList.map(item => ({
					id: item.id + '_f',
					value: item.id,
					pId: 0,
					title: item.title,
					checkable: false
				}))
			}
			this.typeSource = 'classic'
			this.orderTitle = '为顾客订包间'
			this.orderVisible = true
			this.isSubmit = false
			this.getListByCategoryData(item)
		},

		/**
		 * @description: 加桌
		 * @return {*}
		 */
		async onHandleAddRooms() {
			this.currentOrderForm.origin_room_id = this.currentOrderForm.room_id
			// 格式化已选包间ID
			this.currentOrderForm.room_id = this.currentOrderForm.title

			this.isShowRoomList = true
			// 获取连台连订详情
			await getRoomOrderInfo({
				id: this.currentOrderForm.id
			})

			this.roomTreeData = []
			this.roomTreeData = this.categoryList.map(item => ({
				id: item.id + '_f',
				value: item.id,
				pId: 0,
				title: item.title,
				checkable: false
			}))

			this.getListByCategoryData()
		},

		/**
		 * @description: 获取包间分类
		 * @return {*}
		 * @param {*} item
		 * @param {*} banquetActiveKeyId
		 */
		async getListByCategoryData(item, banquetActiveKeyId = 0) {
			this.banquetLoading = true
			this.banquetActiveKey = []

			let {code, data} = await getListByCategory()
			if (code === 0) {
				//获取人生36宴列表
				let id = data.length ? [data[0].id.toString()] : []
				data.forEach(items => {
					// items.disabled = item ? false : true
					items.disabled = false
					items.with_life_feasts.forEach(with_life_feasts => {
						with_life_feasts.ids = `${items.id}_${with_life_feasts.id}`
						if (banquetActiveKeyId && banquetActiveKeyId === with_life_feasts.id) {
							id = [with_life_feasts.category_id]
							this.banqueInfo.cover_img = with_life_feasts.cover_img
							this.currentOrderForm.type = `${items.id}_${with_life_feasts.id}`
						}
					})
				})
				this.banquetList = data
				this.banquetActiveKey = id
			}
			this.banquetLoading = false
		},
		/**
		 * @description: 打印接待单
		 * @return {*}
		 */
		orderPrint() {
			// this.addLoading()
			this.$message.loading({content: '打印中...', duration: 0, key: 'orderPrint'})
			orderPrint({
				date: this.orderDate,
				type: this.orderType
			}).then(res => {
				// this.subLoading()
				if (res.code == '0') {
					this.$warning({
						title: '提示',
						content: '已提交打印任务，请关注小票机打印接待单。'
					})
				}
			})
		},

		// 异步获取包间列表
		onLoadData(treeNode) {
			return new Promise(async resolve => {
				// 构建基础请求参数
				const params = {
					order_date: this.rangeDateArray.length ? this.rangeDateArray.map(item => item.date) : [this.orderDate],
					order_type: [this.orderType]
				}

				// 是否开启连台连订
				if (this.isShowMoreMeal && this.rangeDateArray.length) {
					if (this.moreMealForm.type === '1') {
						params.order_type = [...this.mealSegment.map((meal, index) => (meal.open ? index : -1)).filter(index => index !== -1)]
					} else {
						params.order_type = [...this.rangePickerUniqueMeals]
					}
				}

				try {
					// 如果没有传入 treeNode，初始化分类数据
					if (!treeNode) {
						this.roomTreeData = this.categoryList.map(item => ({
							id: `category_${item.id}`,
							value: item.id,
							pId: 0,
							title: item.title,
							checkable: false,
							key: `category_${item.id}`,
							isLeaf: false,
							children: [] // 初始化空子节点数组
						}))
						resolve()
						return
					}

					// 获取指定分类的数据
					params.category_id = treeNode.dataRef.value

					if (params.category_id === 0) delete params.category_id

					const {data} = await getCanOrderRoom(params)
					const list = (data.list || data || []).map(item => ({
						id: `room_${item.id}`,
						value: item.id,
						pId: treeNode.dataRef.id,
						title: item.title,
						isLeaf: true,
						key: `room_${item.id}`
					}))

					// 更新当前展开节点的子节点
					const index = this.roomTreeData.findIndex(node => node.id === treeNode.dataRef.id)
					if (index > -1) {
						this.$set(this.roomTreeData[index], 'children', list)
					}

					resolve()
				} catch (error) {
					this.$message.error('加载包间数据失败：' + error)

					resolve()
				}
			})
		},

		/**
		 * @description: 编辑预订订单
		 * @return {*}
		 * @param {*} item
		 */
		async editOrderRoom(item) {
			this.initBanqueInfo()
			if (item.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			if (item.order_info.unit === '待定') {
				item.order_info.number = ''
			}
			this.currentOrderForm = {
				..._.cloneDeep(item.order_info),
				title: item.title,
				open_menu: item?.order_info?.order_menu_info?.open_menu === 1 ? true : false, //点菜
				is_private: item?.order_info?.is_private === 1 ? true : false, //私密订单
				type_version: item?.order_info?.type_version === 1 ? true : false //经典样式2
			}
			this.typeSource = item?.order_info?.type_version === 2 ? 'activity' : 'classic'
			// 反显自定义时间
			if (!this.timeList[item.order_info.order_type].includes(item.order_info.order_time)) {
				const t = item?.order_info?.order_time
				const list = this.timeList[item?.order_info?.order_type] || []
				if (t && t !== '待定' && !list.includes(t)) {
					const m = moment(t, ['HH:mm', 'HH:mm:ss'], true)
					this.customOrderTime = m.isValid() ? m : null
				} else {
					this.customOrderTime = null
				}
			}

			let banquetActiveKeyId = 0
			// 反显36宴
			if (item.order_info.order_theme_info && item.order_info.order_theme_info.id) {
				let orderThemeInfo = item.order_info.order_theme_info
				banquetActiveKeyId = orderThemeInfo.id
				this.banqueInfo = {
					feast_name: orderThemeInfo.feast_name || '', //人生36宴名称
					name: orderThemeInfo.name || '',
					id: orderThemeInfo.id,
					theme_img: orderThemeInfo.theme_img || '', //邀请函自定义主题图片
					menu_img: orderThemeInfo.menu_img || '', //邀请函自定义排菜图片
					bg_img: orderThemeInfo.bg_img || '',
					invitation_img: orderThemeInfo.invitation_img || '', //邀请函自定义分享封面
					music_url: orderThemeInfo.music_url || '' //背景音乐
				}
			}
			if (item.order_info.deposit_info && item.order_info.deposit_info.length) {
				//编辑已下定金
				this.reservationInfo = {
					list: item.order_info.deposit_info.map(item => {
						let itemData = {
							receipt_number: item.receipt_number,
							pay_image: item.pay_image,
							pay_money: item.pay_money,
							pay_type: item.pay_type,
							id: item.id,
							status: item.status,
							reservationType: 1
						}
						if (item.print_status && item.print_status === 1) {
							//定金已打印
							itemData.reservationType = 3
						} else if (item.pay_status && item.pay_status === 2) {
							//定金已退款
							itemData.reservationType = 4
						} else if (item.with_check && item.with_check.id) {
							//定金已核销
							itemData.reservationType = 2
						}
						return itemData
					})
				}
			} else {
				this.initReservationInfo()
			}
			//连台编辑禁用新邀请函
			// this.orderTypes[this.orderTypes.length - 1].disabled = item.order_info.relation ? true : false
			this.orderTitle = '修改包间预订信息'
			this.orderVisible = true
			this.isSubmit = false
			this.isShowOrderDetail = false
			this.getListByCategoryData(item.order_info.relation ? false : true, banquetActiveKeyId)
		},

		/**
		 * @description: 预定下单
		 * @return {*}
		 */
		orderRoomConfirm(sendSms) {
			// 是否正在提交
			if (this.isSubmit) return
			// 备用金不足发短信
			if (sendSms === 1 && this.storeMoney < 20 && !this.currentOrderForm.id) {
				this.showMoneyTip = true
				this.orderVisible = false
				return
			}
			let currentOrderForm = JSON.parse(JSON.stringify(this.currentOrderForm))
			// 是否开启菜单
			currentOrderForm.open_menu = currentOrderForm.open_menu ? 1 : 0
			// 是否私密订单
			currentOrderForm.is_private = currentOrderForm.is_private ? 1 : 0
			// 是否为新年限定/经典样式2
			currentOrderForm.type_version = this.typeSource === 'activity' ? 2 : currentOrderForm.type_version ? 1 : 0
			this.$refs.order.validate().then(() => {
				let {list} = this.reservationInfo
				let payTypeIndex = list.findIndex(item => item.pay_type === '' || !item.pay_type) //定金支付方式为空
				let payMoneyIndex = list.findIndex(item => item.pay_money === '' || !item.pay_money) //定金金额为空
				const reg = /^\d+$/
				let tips = ''
				let payMoneyIntegerIndex = list.findIndex(item => item.pay_money && !reg.test(item.pay_money)) //定金金额为空
				if (payTypeIndex >= 0) {
					tips = '请选择定金支付方式！'
				}
				if (payMoneyIndex >= 0) {
					tips = '请输入定金金额！'
				}
				if (payMoneyIntegerIndex >= 0) {
					tips = '定金金额为整数！'
				}
				if (tips) {
					this.$message.error({
						content: tips,
						key: 'order'
					})

					return
				}

				if (this.orderTitle === '为顾客订包间') {
					let data = {
						...currentOrderForm,
						order_date: this.orderDate,
						order_round: this.orderRound,
						order_type: this.orderType,
						send_sms: sendSms
					}

					// 获取开启的餐段索引
					let rangeOpenIndexArray = this.mealSegment.map((item, index) => (item.open ? index : -1)).filter(index => index !== -1)
					// 连台连订订单需要构建参数字段
					if ((this.moreMealForm.type === '1' && this.isShowMoreMeal && !this.rangeAllOrderTimesValue) || (this.moreMealForm.type === '2' && this.isShowMoreMeal && this.rangeOrderTimes.filter(item => item).length < this.rangePickerUniqueMeals.length && this.rangeOrderTimes.filter(item => item).length < rangeOpenIndexArray.length)) {
						if (!this.rangeDateArray.length) this.$message.error('请先选择日期和餐段!')
						else this.$message.error('请先选择预计到店时间！')

						return
					}

					// 连台连订全天
					if (this.isShowMoreMeal && this.moreMealForm.type === '1' && this.rangeAllOrderTimesValue) {
						const paramsRangeDateArray = _.cloneDeep(this.rangeDateArray)
						// 获取开启的餐段索引
						const openMealIndices = this.mealSegment.map((meal, index) => (meal.open ? index : -1)).filter(index => index !== -1)
						// 为每个日期创建相同的餐段数组
						const paramsSelectedMeals = paramsRangeDateArray.map(() => openMealIndices)
						const order_date_list = paramsRangeDateArray.map((item, index) => {
							return {
								date: item.date,
								order_type: paramsSelectedMeals[index].map(item_child => {
									return {
										type: item_child,
										time: this.rangeAllOrderTimesValue
									}
								})
							}
						})

						// 赋值连台连订
						data.order_date_list = _.cloneDeep(order_date_list)
					}

					// 连台连订指定餐段
					if (this.isShowMoreMeal && this.moreMealForm.type === '2' && this.rangeDateArray.length && this.rangePickerUniqueMeals) {
						const paramsRangeDateArray = _.cloneDeep(this.rangeDateArray)

						// 获取第一个非空值的索引
						const order_date_list = paramsRangeDateArray.map((item, index) => {
							return {
								date: item.date,
								order_type: this.rangePickerSelectedMeals[index]
									.map(item_child => {
										if (item_child - 1 >= 0) {
											return {
												type: item_child - 1,
												time: this.rangeOrderTimes[item_child - 1]
											}
										}
										return null
									})
									.filter(item => item !== null)
							}
						})

						// 赋值连台连订
						data.order_date_list = _.cloneDeep(order_date_list)
					}

					// 填充原连台订单默认字段
					if (this.isShowMoreMeal) {
						data.order_date = data.order_date_list[0].date
						data.order_time = data.order_date_list[0].order_type[0].time
						data.order_type = data.order_date_list[0].order_type[0].type
						// 连台连订暂停轮训
						this.stopLoop()
						this.stopLoopNotice()
					}

					// 剔除自定义代号字段
					if (data.hasOwnProperty('dining_name') && !data.dining_name) delete data.dining_name

					// 剔除预订目的
					if (!data.ding_type) delete data.ding_type

					// 重置待定人数
					if (data.unit === '待定') data.number = 0

					this.$message.loading({content: '预订中', duration: 0, key: 'order'})
					this.orderLoading = true
					this.isSubmit = true
					// 选择主题人生36宴
					if (this.banqueInfo && this.banqueInfo.id) {
						let banqueInfo = this.banqueInfo
						data.type = 7 //类型调整为7
						data.type_version = 0 // 重置样式
						let banquetList = this.banquetList
						let banquetsInfo = banquetList.flatMap(item => item.with_life_feasts).find(feast => feast.id === banqueInfo.id)
						data.order_theme_info = {
							name: banqueInfo.name || '',
							theme_img: banqueInfo.theme_img || banquetsInfo.theme_img,
							menu_img: banqueInfo.menu_img || banquetsInfo.menu_img,
							id: banqueInfo.id,
							feast_name: banqueInfo.feast_name || banquetsInfo.feast_name,
							bg_img: banqueInfo.bg_img || '',
							invitation_img: banqueInfo.invitation_img || '',
							music_url: banquetsInfo.music_url || '' //背景音乐
						}
					}
					orderRoom(data).then(async res => {
						if (res.code === 0) {
							await this.setDeposit(res.data.order.id) //定金
							this.$message.success({
								content: '预订成功！',
								key: 'order'
							})
							this.reservationInfo = {
								list: []
							}
							this.roomTreeData = []
							this.customOrderTime = null
							this.isShowOrderDetail = false
							this.isShowMoreMeal = false
							this.orderVisible = false
							this.orderLoading = false
							// 已选择连台连订
							if (this.isShowMoreMeal && this.rangeDateArray.length && this.rangePickerUniqueMeals.length) {
								this.rangeDateArray = []
								this.rangePickerStartDate = null
								this.rangePickerEndDate = null
								this.rangePickerSelectedMeals = []
								this.rangePickerUniqueMeals = []
								this.moreMealForm = {
									type: '1',
									range: []
								}
								this.isShowMoreMeal = false
							}

							this.getList()
						} else {
							this.isSubmit = false
						}
					})
				} else {
					if (currentOrderForm.relation) {
						this.$confirm({
							title: '提示',
							content: '该订单为连台订单，是否需要一起操作？',
							okText: '是',
							cancelText: '否',
							onOk: () => {
								this.handleEditOrder({
									...currentOrderForm,
									edit_relation: 1
								})
							},
							onCancel: () => {
								this.handleEditOrder({
									...currentOrderForm,
									edit_relation: 0
								})
							}
						})
					} else {
						this.handleEditOrder({
							...currentOrderForm,
							send_sms: sendSms
						})
					}
				}
			})
		},
		// 定金提交
		async setDeposit(order_id) {
			let {reservationInfo} = this
			if (reservationInfo.list.length === 0) return //新订单未开启 不需要提交
			let reservationType2 = reservationInfo.list.find(item => item.reservationType === 1 || item.reservationType === 0)
			if (!reservationType2) return //已核销 已打印 不需要提交
			let param = JSON.parse(JSON.stringify(reservationInfo))
			let list = param.list.map(item => {
				item.pay_type = parseFloat(item.pay_type)
				item.status = 1
				delete item.reservationType
				delete item.receipt_number
				return item
			})

			this.$message.loading({content: '预订中', key: 'order'})
			await setDeposit({
				list,
				order_id
			})
		},
		/**
		 * @description: 修改预订订单
		 * @return {*}
		 * @param {*} data // 参数JSON对象
		 */
		handleEditOrder(data) {
			if (this.isSubmit) return

			this.$message.loading({content: '修改中', duration: 0, key: 'order'})
			this.orderLoading = true
			this.isSubmit = true

			// 剔除不能传空值的key
			if (data.hasOwnProperty('dining_name') && !data.dining_name) {
				delete data.dining_name
			}
			// 剔除预订目的
			if (!data.ding_type) delete data.ding_type

			if (data.unit === '待定') data.number = 0

			// 选择主题人生36宴
			if (this.banqueInfo && this.banqueInfo.id) {
				// 选择主题人生36宴
				let banqueInfo = this.banqueInfo
				data.type = 7 //类型调整为7
				let banquetList = this.banquetList
				let banquetsInfo = banquetList.flatMap(item => item.with_life_feasts).find(feast => feast.id === banqueInfo.id)
				data.order_theme_info = {
					name: banqueInfo.name || '',
					theme_img: banqueInfo.theme_img || banquetsInfo.theme_img,
					menu_img: banqueInfo.menu_img || banquetsInfo.menu_img,
					id: banqueInfo.id,
					feast_name: banqueInfo.feast_name || banquetsInfo.feast_name,
					bg_img: banqueInfo.bg_img || banquetsInfo.bg_img,
					invitation_img: banqueInfo.invitation_img || '',
					music_url: banquetsInfo.music_url || '' //背景音乐
				}
			}
			// 是否为单张转连台
			if (data.origin_room_id && data.room_id.length > 1) data.edit_relation = 1
			else {
				if (data.edit_relation) data.edit_relation = 1
				else data.edit_relation = 0
			}
			// 是否为加桌
			if (data.room_id.length > 1 && data.origin_room_id) {
				const tmpOriginRoomIdIndex = data.room_id.findIndex(item => item === data.title)
				data.room_id.splice(tmpOriginRoomIdIndex, 1, data.origin_room_id)

				delete data.origin_room_id
			}

			orderRoom(data).then(async res => {
				if (res.code === 0) {
					await this.setDeposit(data.id) //定金

					this.$message.success({
						content: '修改成功！',
						key: 'order'
					})

					this.roomTreeData = []
					this.reservationInfo = {
						list: []
					}
					this.orderVisible = false
					this.isShowOrderDetail = false
					this.isShowMoreMeal = false
					this.isShowRoomList = false
					this.orderLoading = false
					this.getList()
				} else {
					this.isSubmit = false
				}
			})
		},
		closeCancelOrder() {
			this.cancelOrderVisible = false
		},
		showCancelOrder(item) {
			if (item.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			if (this.shopConfig.disable_cancel_change == 1 && item.order_info.mini_user_openid) {
				this.$message.error({
					content: '无法取消该订单，请联系销售取消！',
					key: 'order'
				})

				return
			}

			this.cancelOrderVisible = true
			this.currentOrder = item
		},
		/**
		 * @description: 取消预订订单
		 * @return {*}
		 * @param {*} send // 是否需要发送短信0不需要 1需要
		 */
		cancelOrder(send = 0) {
			if (this.currentOrder && this.currentOrder.order_info.relation) {
				this.$confirm({
					title: '提示',
					content: '该订单为连台订单，是否需要一起操作？',
					okText: '是',
					cancelText: '否',
					onOk: () => {
						this.handleCancelOrder(send, 1)
					},
					onCancel: () => {
						this.handleCancelOrder(send, 0)
					}
				})
			} else {
				this.handleCancelOrder(send, 0)
			}
		},
		/**
		 * @description: 处理取消预订订单
		 * @return {*}
		 * @param {*} send // 是否需要发送短信0不需要 1需要
		 * @param {*} cancel_relation // 是否需要连台取消0不需要 1需要
		 */
		handleCancelOrder(send, cancel_relation) {
			this.cancelLoading = true
			cancelOrderRoom({
				id: this.currentOrder.order_info.id,
				send,
				cancel_relation
			}).then(res => {
				this.cancelOrderVisible = false
				this.cancelLoading = false
				this.isShowOrderDetail = false

				if (res.code === 0) {
					this.$message.success({
						content: '操作成功！',
						key: 'order'
					})
					this.getList()
				}
			})
		},
		/**
		 * 清台
		 * */
		settlement(item) {
			if (item.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			if (item.order_info.is_private === 1) {
				this.$message.error({
					content: '私密订单无法操作结算清台',
					key: 'statusRoom'
				})
				return
			}
			if (this.$store.state.user.info.shop && !this.$store.state.user.info.shop.commission > 0) {
				this.$confirm({
					title: '提示',
					content: '你确定清台该包间吗？',
					onOk: () => {
						this.$message.loading({
							content: '清台中',
							key: 'order'
						})
						settlement({
							id: item.order_info.id,
							money: 0
						}).then(res => {
							if (res.code === 0) {
								this.$message.success({
									content: '清台成功！',
									key: 'order'
								})
								this.settlementVisible = false
								this.isShowOrderDetail = false

								this.getList()
							}
						})
					}
				})
				return
			}
			this.settlementForm = _.cloneDeep(item)
			this.settlementVisible = true
		},
		settlementConfirm() {
			this.$refs.settlement
				.validate()
				.then(() => {
					this.$message.loading({content: '清台中', key: 'order'})
					settlement({
						id: this.settlementForm.order_info.id,
						money: this.settlementForm.money
					}).then(res => {
						if (res.code === 0) {
							this.$message.success({
								content: '清台成功！',
								key: 'order'
							})
							this.settlementVisible = false
							this.isShowOrderDetail = false

							this.getList()
						}
					})
				})
				.catch(err => err)
		},
		/**
		 * 占座
		 * */
		takeUp(item) {
			if (item.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			takeUpSeat({
				room_id: item.id,
				order_type: this.orderType,
				date: this.orderDate,
				order_round: this.orderRound || 1
			}).then(res => {
				if (res.code === 0) {
					this.getList()
				}
			})
		},
		/**
		 * @description: 转台弹窗
		 * @return {*}
		 * @param {*} item 需要转台订单
		 */
		showChangeRoom(item) {
			if (item.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			this.recordBefore = item // 发起转台订单
			this.changeRoomVisible = true
			this.changeRoomOrderId = item.order_info.id || ''
			this.changeRoomRelation = item.order_info.relation || ''
			this.changeRoomOrderType = this.orderType
			this.changeRoomOrderRound = this.orderRound

			this.getChangeRoomList()
		},
		/**
		 * @description: 选择预计到店时间
		 * @return {*}
		 * @param {*} item
		 */
		onSelectOrderTime(item, type) {
			this.record = item // 被转台订单
			if (type == '1') this.changeRoom()
			else this.showOrderTime = true
		},

		/**
		 * @description: 选择连台连订预计到店时间
		 * @return {*}
		 */
		handleRangeOrderTime(type, item) {
			if (type === 'rangeAllOrderTimesValue') this.rangeAllOrderTimesValue = item
			else this.rangeOrderTimes[type] = item

			this.showOrderTime = false
		},

		/**
		 * @description: 处理预计到店时间
		 * @return {*}
		 * @param {*} item
		 */
		handleOrderTime(item) {
			this.changeOrderTime = item
			this.changeRoom()
		},
		/**
		 * @description: 转台/调换
		 * @return {*}
		 */
		async changeRoom() {
			let {id, order, order_info} = this.record
			let tempResult
			// 0不发SMS 1发SMS
			if (this.changeRoomSMS == '1') {
				this.$message.loading({content: '转台中', key: 'changeRoom'})
				if (order == '1') {
					// 调换
					tempResult = await exchangeRoom({
						id: this.changeRoomOrderId,
						exchange_id: order_info.id
					})
				} else {
					// 转台
					tempResult = await changeRoom({
						id: this.changeRoomOrderId,
						room_id: id,
						order_date: this.changeRoomDate,
						order_time: this.changeOrderTime,
						order_round: this.changeRoomOrderRound,
						order_type: this.changeRoomOrderType
					})
				}

				if (tempResult.code !== '1') {
					this.isCompleteChangeRoom = true
					// 切换到转台/调换成功后的日期和餐段
					this.orderDate = this.changeRoomDate
					this.orderRound = this.changeRoomOrderRound
					this.orderType = this.changeRoomOrderType
					this.getList()

					this.changeRoomVisible = false
					this.isShowOrderDetail = false
					this.showOrderTime = false

					this.$confirm({
						title: '提示',
						content: `${order == '1' ? '调换' : '转台'}成功，是否发送短信给预订人？`,
						cancelText: '否',
						okText: '是',
						closable: true,
						onOk: async () => {
							this.$message.loading({
								content: '短信发送中',
								key: 'changeRoom'
							})
							// 转台
							if (order == '0') {
								let {code} = await sendSms({
									order_id: this.changeRoomOrderId
								})
								if (code == '0') {
									this.$message.success({
										content: '发送成功！',
										key: 'changeRoom'
									})
								}
							}
							// 调换
							if (order == '1' && order_info?.id) {
								Promise.all([
									sendSms({
										order_id: this.changeRoomOrderId
									}),
									sendSms({order_id: order_info?.id})
								]).then(res => {
									if (res[0].code == '0' && res[1].code == '0') {
										this.$message.success({
											content: '短信发送成功！',
											key: 'changeRoom'
										})
									}
								})
							}
						}
					})
				}
			} else {
				this.$confirm({
					title: '提示',
					content: order == '1' ? '该餐位已有预订，是否调换转台？' : '确认转台到该餐位吗？',
					onOk: async () => {
						this.$message.loading({
							content: '转台中',
							key: 'changeRoom'
						})
						if (order == '1') {
							// 调换
							tempResult = await exchangeRoom({
								id: this.changeRoomOrderId,
								exchange_id: order_info.id
							})
						} else {
							// 转台
							tempResult = await changeRoom({
								id: this.changeRoomOrderId,
								room_id: id,
								order_date: this.changeRoomDate,
								order_time: this.changeOrderTime,
								order_round: this.changeRoomOrderRound,
								order_type: this.changeRoomOrderType
							})
						}

						if (tempResult.code !== '1') {
							this.$message.success({
								content: '转台成功！',
								key: 'changeRoom'
							})
							this.isCompleteChangeRoom = true
							// 切换到转台/调换成功后的日期和餐段
							this.orderDate = this.changeRoomDate
							this.orderRound = this.changeRoomOrderRound
							this.orderType = this.changeRoomOrderType
							this.getList()

							this.changeRoomVisible = false
							this.isShowOrderDetail = false
							this.showOrderTime = false
						} else {
							this.$message.error({
								content: '转台失败！请重试！',
								key: 'changeRoom'
							})
						}
					}
				})
			}
		},
		/**
		 * @description 日期加减
		 * @param isPlus{boolean} 是否增加
		 * */
		changeRoomOptDate(isPlus) {
			const date = moment(this.changeRoomDate)
			let result
			if (isPlus) {
				result = date.add(1, 'd').format('YYYY-MM-DD')
			} else {
				result = date.subtract(1, 'd').format('YYYY-MM-DD')
			}
			this.changeRoomDate = result
		},
		/**
		 * @description 日期加减
		 * @param isPlus{boolean} 是否增加
		 * */
		operationDate(isPlus) {
			const date = moment(this.orderDate)
			let result
			if (isPlus) {
				result = date.add(1, 'd').format('YYYY-MM-DD')
			} else {
				result = date.subtract(1, 'd').format('YYYY-MM-DD')
			}

			this.orderDate = result
		},
		/**
		 * @description: 判断是否为节假日
		 * @return {*}
		 * @param {*} date
		 */
		isHoliday(date) {
			getIsHoliday({date}).then(res => {
				this.holiday = res.data.is_holiday
				this.is_holiday_meal_segment = res.data.meal_segment
			})
		},
		/**
		 * 获取员工或者移动工作台绑定人员
		 * */
		getEmployees() {
			if (this.hasCorpId) {
				getEmployeeList().then(res => {
					if (res.code === 0) {
						this.employeeList = res.data
					}
				})
			} else {
				getIsBindingList().then(res => {
					if (res.code === 0) {
						this.employeeList = res.data
					}
				})
			}
		},
		/**
		 * @description: 操作客已到状态
		 * @return {*}
		 * @param {*} item 当前项
		 */
		clickClientArrive(item) {
			if (item.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			this.$confirm({
				title: '提示',
				content: '确认该顾客已到店了吗？',
				onOk: () => {
					if (item.isEven) {
						this.$confirm({
							title: '提示',
							content: '该订单为连台订单，是否需要一起操作？',
							okText: '是',
							cancelText: '否',
							onOk: () => {
								this.handleClientArrive(item.order_info.id, 1)
							},
							onCancel: () => {
								this.handleClientArrive(item.order_info.id, 0)
							}
						})
					} else {
						this.handleClientArrive(item.order_info.id, 0)
					}
				}
			})
		},
		/**
		 * @description: 操作可以到提示
		 * @return {*}
		 * @param {*} id // 订单ID
		 * @param {*} relation // 是否需要连台取消0不需要 1需要
		 */
		handleClientArrive(id, arrive_relation) {
			this.$message.loading({content: '确认中', key: 'order'})
			clientArrive({
				id,
				arrive_relation
			}).then(res => {
				if (res.code === 0) {
					this.$message.success({
						content: '确认成功！',
						key: 'order'
					})
					this.isShowOrderDetail = false

					this.getList()
				}
			})
		},
		closeMoneyTip() {
			this.showMoneyTip = false
		},
		/**
		 * @description: 快搜
		 * @return {*}
		 */
		async onQuickSearch(type) {
			this.isShowQuickSearch = type
			// 取消快搜后重置状态为全部
			// 重置快搜输入内容
			// 初始默认全部重置
			this.quickSearchKeywordList = []
			this.quickSearchPhoneValue = ''
			this.quickSearchPhoneList.map(item => {
				item.focus = false
				item.value = ''
			})
			if (!type) {
				this.roomStatus = 0
				return
			}

			// 获取订单
			let params = {
				category_id: this.category,
				order_date: this.orderDate,
				order_type: this.orderType,
				status: 0
			}
			this.isShowQuickSearchLoading = true
			// 全部分类剔除分类ID
			if (params.category_id === 0) delete params.category_id
			// V3接口获取包间列表
			let {code, data} = await getRoomListV3(params)
			let tempKeywordList = []
			this.isShowQuickSearchLoading = false
			if (code === 0) {
				data.forEach(item => {
					if (item.order_info && item.order_info.name) {
						tempKeywordList.push(item.order_info.name)
					}
				})
				this.quickSearchKeywordList = [...new Set(JSON.parse(JSON.stringify(tempKeywordList)))]
				this.quickSearchPhoneList[0].focus = true // 触发自动焦点
			}
		},
		/**
		 * @description: 监听手机号输入
		 * @return {*}
		 */
		onChangeSearchPhone(ev) {
			this.quickSearchPhoneList.forEach((item, index) => {
				if (ev.data && index === this.quickSearchPhoneValue.length - 1) {
					item.value = ev.data
					item.focus = false
				}
				if (!ev.data && index === this.quickSearchPhoneValue.length) {
					item.value = ev.data
					item.focus = true
				} else {
					item.focus = false
				}
			})
			// 激活下一个焦点
			let tmpCurrentIndex = this.quickSearchPhoneList.findIndex(item => !item.value)
			if (tmpCurrentIndex !== -1) {
				this.quickSearchPhoneList[tmpCurrentIndex].focus = true
			}
			// 手机号后四位匹配搜索
			if (this.quickSearchPhoneValue.length === 4) {
				this.isShowQuickSearch = false
				this.getList()
			}
		},
		/**
		 * @description: 根据预订人名字快速搜索
		 * @return {*}
		 * @param {*} name
		 */
		onChangeSearchName(name) {
			this.quickSearchPhoneValue = name
			this.isShowQuickSearch = false
			this.getList()
		},
		/**
		 * @description: 监听多轮餐段选择
		 * @return {*}
		 * @param {*} ev
		 * @param {*} orderType 餐段类型
		 * @param {*} orderRound 餐段轮次
		 * @param {*} isChangeRoom 是否为转台
		 */
		onChangeMealSegmentRound(ev, orderType, orderRound, isChangeRoom = false) {
			// 是否为转台
			if (isChangeRoom) {
				if (this.changeRoomOrderType !== orderType) {
					this.changeRoomOrderType = orderType
					this.changeRoomOrderRound = orderRound
				} else {
					if (this.changeRoomOrderRound !== orderRound) {
						this.changeRoomOrderRound = orderRound
						this.getChangeRoomList()
					}
				}
			} else {
				if (this.orderType !== orderType) {
					this.orderType = orderType
					this.orderRound = orderRound
				} else {
					if (this.orderRound !== orderRound) {
						this.orderRound = orderRound
						this.getList()
					}
				}
			}
		},
		/**
		 * @description: 打开小卡片详情
		 * @return {*}
		 * @param {*} order
		 */
		onCheckDetail(order) {
			if (order.status === 0) {
				this.$message.error({
					content: '当前餐位已被禁用',
					key: 'statusRoom'
				})
				return
			}
			this.modalOrderDetail = order
			this.isShowOrderDetail = true
		},
		/**
		 * @description: 关闭并清空小卡片订单详情
		 * @return {*}
		 */
		handleCloseDetail() {
			this.isShowOrderDetail = false
			this.modalOrderDetail = {
				order_info: {}
			}
		},
		/**
		 * @description: 监听Tab切换
		 * @return {*}
		 */
		handleTabChange(activeKey) {
			if (this.isShowSmallCard) {
				this.$nextTick(() => {
					const anchor = document.getElementById(`category-${activeKey}`)
					if (anchor) {
						// 精确计算滚动位置
						const {top} = anchor.getBoundingClientRect()
						const fixedHeaderHeight = 180 // 根据实际顶部固定区域高度调整
						const scrollTop = activeKey === 0 ? 0 : window.scrollY + top - fixedHeaderHeight

						window.scrollTo({
							top: scrollTop,
							behavior: 'smooth'
						})
					}
				})
			} else {
				this.getList()
			}
		},
		/**
		 * @description: 处理切换小卡片模式
		 * @return {*}
		 */
		handleSmallCard() {
			this.isShowSmallCard = !this.isShowSmallCard
			this.isInitCard = false

			localStorage.setItem('showSmallCard', JSON.stringify(this.isShowSmallCard))
		},
		/**
		 * @description: 返回顶部
		 * @return {*}
		 */
		onScrollTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		},

		/**
		 * @description: 刷新列表
		 * @return {*}
		 */
		onScrollRefresh() {
			this.getList()
		},

		/**
		 * @description: 操作连台连订显示日期和餐段弹窗
		 * @return {*}
		 */
		onHandleMoreMealPopup(type = 0) {
			if (type === 1) {
				this.$refs.moreMeal
					.validate()
					.then(() => {
						if (this.rangeMultiRooms.length) {
							this.$message.warning('因该餐段时间发生改变，请重新选择包间')

							this.rangeMultiRooms = []
						}

						// 全天选中
						if (this.moreMealForm.type === '1') {
							// 获取开启的餐段索引
							const openMealIndices = this.mealSegment.map((meal, index) => (meal.open ? index : -1)).filter(index => index !== -1)

							// 根据开启的餐段索引获取对应的时间并展开
							const rangeAllOrderTimes = openMealIndices
								.map(index => this.timeList[index])
								.flat()
								.reduce((acc, curr) => {
									if (curr !== '待定') {
										acc.push(curr)
									}

									return acc
								}, [])

							// 如果原数组中包含"待定"，将其添加到最后
							if (
								openMealIndices
									.map(index => this.timeList[index])
									.flat()
									.includes('待定')
							) {
								rangeAllOrderTimes.push('待定')
							}

							this.rangeAllOrderTimes = _.cloneDeep(rangeAllOrderTimes)
							// 清空指定餐段已选择内容
							this.rangePickerSelectedMeals = []
							this.rangePickerUniqueMeals = []

							this.isShowMoreMeal = true
							this.isShowMoreMealPopup = false

							this.resetAndReloadTreeData()
						} else {
							if (!this.rangePickerSelectedMeals.every(item => item.length)) {
								this.$message.error('每个日期至少选择一个餐段！')

								return
							}
							// 每次确认保存先重置餐段并集
							this.rangePickerUniqueMeals = []

							// 取日期合集所有餐段的并集
							const processedMeals = this.rangePickerSelectedMeals.map(subArray => subArray.map(num => num - 1).filter(num => num >= 0))
							this.rangePickerUniqueMeals = [...new Set(processedMeals.flat())].sort((a, b) => a - b)

							this.rangeOrderType = null
							this.rangeOrderTimes = ['', '', '', '']
							// 清空全天已选择内容
							this.rangeAllOrderTimes = []
							this.rangeAllOrderTimesValue = ''

							this.isShowMoreMeal = true
							this.isShowMoreMealPopup = false

							this.resetAndReloadTreeData()
						}
					})
					.catch(err => {
						if (!err) this.$message.error('请先选择日期！')
					})
			} else {
				if (!this.rangeDateArray.length) this.isShowMoreMeal = false

				this.isShowMoreMealPopup = !this.isShowMoreMealPopup
			}
		},

		/**
		 * @description: 重置并重新加载树数据的方法
		 * @return {*}
		 */
		resetAndReloadTreeData() {
			// 清空展开状态和选中值
			this.expandedKeys = []
			if (this.currentOrderForm.room_id.length) {
				this.currentOrderForm.room_id = []
			}

			// 先清空树数据
			this.roomTreeData = []

			this.$nextTick(async () => {
				// 强制更新组件
				if (this.$refs.roomTreeSelect) {
					this.$refs.roomTreeSelect.$forceUpdate()
				}

				// 重新加载数据
				await this.onLoadData()
			})
		},

		/**
		 * @description: 选择日期范围
		 * @return {*}
		 */
		onChangeRangePicker(dates) {
			if (dates && dates.length === 2) {
				this.rangePickerStartDate = dates[0]
				this.rangePickerEndDate = dates[1]

				// 预定义全部餐段选项
				const allMealOption = {
					name: '全部',
					open: true,
					time_ranger: []
				}
				// 选择完成后检查日期区间是否超过3天
				const daysDiff = dates[1].diff(dates[0], 'days') + 1

				if (daysDiff > 3) {
					// 超过3天，将结束日期自动调整为开始日期后的第三天
					const newRangePickerEndDate = moment(dates[0]).add(2, 'days').endOf('day')
					// 可选择清空日期选择器
					this.rangePickerEndDate = newRangePickerEndDate
					// 更新v-model绑定的值
					this.moreMealForm.range = [dates[0], newRangePickerEndDate]
					// 如果超过3天，重置选择并提示用户
					this.$message.warning('日期区间最多选择3天，已自动调整')
				}

				// 创建日期范围数组
				let rangeDateArray = []

				// 临时日期变量用于遍历
				let currentDate = moment(this.rangePickerStartDate)

				// 一次性深拷贝餐段数据，避免循环中重复操作
				let allMealSegment = [allMealOption, ..._.cloneDeep(this.mealSegment)]
				// 当前日期小于等于结束日期时，循环添加日期
				while (currentDate.isSameOrBefore(this.rangePickerEndDate, 'day')) {
					// 以YYYY-MM-DD格式添加日期到数组
					// 创建所选择日期对应的全部餐段数据
					rangeDateArray.push({
						date: currentDate.format('YYYY-MM-DD'),
						meal: _.cloneDeep(allMealSegment) // 使用深拷贝确保每天的餐段数据独立
					})
					// 增加一天
					currentDate = currentDate.clone().add(1, 'days')
				}

				this.rangePickerSelectedMeals = rangeDateArray.map(() => []) // 为每天创建一个空数组存储选中的餐段
				this.rangeDateArray = [...rangeDateArray]
			} else {
				// 重置清空已选
				this.rangeDateArray = []
				this.rangePickerStartDate = null
				this.rangePickerEndDate = null
				this.rangePickerSelectedMeals = []
				this.rangePickerUniqueMeals = []
				this.moreMealForm.range = []
			}
		},

		/**
		 * @description: 动态限制选择的日期
		 * @return {*}
		 * @param {*} current
		 */
		disabledRangePickerDate(current) {
			// 禁用昨天及之前的日期(今天可选)
			const yesterday = moment().subtract(1, 'days').endOf('day')
			const isBeforeToday = current && current < yesterday

			// 如果已选择开始日期，限制结束日期最多为开始日期后的2天(总共3天)
			if (this.rangePickerStartDate && !this.rangePickerEndDate) {
				const thirdDay = moment(this.rangePickerStartDate).add(3, 'days').startOf('day')
				return isBeforeToday || current >= thirdDay
			}

			return isBeforeToday
		},

		/**
		 * @description: 当关闭选择器时重置临时状态
		 * @return {*}
		 * @param {*} open
		 */
		resetRangePicker(open) {
			if (!open) {
				this.rangePickerStartDate = null
				this.rangePickerEndDate = null
			}
		},

		/**
		 * @description: 点击全选/单个选择
		 * @return {*}
		 * @param {*} dateIndex
		 */
		onMealChange(dateIndex) {
			// 获取当前选中状态和总选项数
			const selectedIndices = [...this.rangePickerSelectedMeals[dateIndex]]
			const totalOptions = this.rangeDateArray[dateIndex].meal.length

			// 1. 处理点击"全部"选项的情况
			const isAllOptionClicked = selectedIndices.includes(0)
			// 修改判断逻辑：当选中数量等于总选项数-1（除去"全部"选项）时，认为是全选状态
			const wasAllSelected = selectedIndices.length === totalOptions - 1

			if (isAllOptionClicked) {
				if (wasAllSelected || selectedIndices.length === totalOptions) {
					this.rangeDateArray[dateIndex].show = false

					if (this.rangePickerSelectedMeals[dateIndex][0] === 0) {
						// 取消任意一个，把“全部”也同步取消
						this.rangePickerSelectedMeals[dateIndex].shift()
					}
				} else {
					// 给“全部”打标记
					this.rangeDateArray[dateIndex].show = true
					// 否则全选
					this.$set(
						this.rangePickerSelectedMeals,
						dateIndex,
						Array.from({length: totalOptions}, (_, i) => i)
					)
				}

				return
			}

			// 2. 处理选择其他选项的情况
			const nonAllSelectedCount = selectedIndices.length

			// 当选中所有非"全部"选项时自动添加"全部"
			if (nonAllSelectedCount === totalOptions - 1) {
				if (this.rangeDateArray[dateIndex].show) {
					this.rangeDateArray[dateIndex].show = false

					this.$set(this.rangePickerSelectedMeals, dateIndex, [])
				} else {
					this.rangeDateArray[dateIndex].show = true

					this.$set(this.rangePickerSelectedMeals, dateIndex, [0, ...selectedIndices])
				}
			} else {
				// 移除"全部"选项，保留其他选中项
				this.$set(
					this.rangePickerSelectedMeals,
					dateIndex,
					selectedIndices.filter(i => i !== 0)
				)
			}
		},

		/**
		 * @description: 包间树选择值发生变化
		 * @return {*}
		 * @param {*} value
		 */
		onChangeTreeSelect(value) {
			this.rangeMultiRooms = value

			if (this.isShowRoomList && value.length < 1) {
				this.isShowRoomList = false

				if (this.currentOrderForm.room_id.length < 1) {
					this.currentOrderForm.room_id = this.currentOrderForm.origin_room_id
				}
			}
		},

		/**
		 * @description: 选择人生36宴
		 * @return {*}
		 * @param {*} e
		 */
		onBanquet(e) {
			let banqueInfo = {
				feast_name: e.name ? e.name : '',
				id: e.id ? e.id : '',
				name: '',
				cover_img: e.cover_img ? e.cover_img : '',
				menu_img: e.menu_img ? e.menu_img : '',
				theme_img: e.theme_img ? e.theme_img : '',
				bg_img: e.bg_img || '',
				invitation_img: e.theme_img ? e.theme_img : '', //邀请函自定义封面图片
				music_url: e.music_url || '' //背景音乐
			}
			this.banqueInfo = banqueInfo
			if (e && e.id) {
				this.typeSource = 'banquet'
			}
			// 重制经典样式2数据
			if (e) {
				this.onChangeTypeVersion(false)
				this.currentOrderForm.type_version = false
			}
		},
		// 上传人生36图片配置
		upBanqueInfoImage(file, type) {
			const reader = new FileReader()
			reader.onload = e => {
				let url = ''
				if (typeof e.target.result === 'object') {
					// 把Array Buffer转化为blob 如果是base64不需要
					url = window.URL.createObjectURL(new Blob([e.target.result]))
				} else {
					url = e.target.result
				}
				//宽高比例 背景比例
				const proportionObj = {
					menu_img: [343, 100],
					theme_img: [750, 780],
					invitation_img: [5, 4]
				}
				this.upBanqueImageConfig = {
					show: true,
					url,
					viewShow: false,
					viewImage: '',
					key: type,
					fixedNumber: proportionObj[type]
				}
			}
			reader.readAsDataURL(file)
			// 阻止默认上传行为
			return false
		},
		// 关闭裁剪
		closeModal() {
			this.upBanqueImageConfig = {
				show: false,
				url: '',
				viewShow: false,
				viewImage: '',
				key: ''
			}
		},
		// 预览裁剪图片
		viewBanqueImage(url) {
			this.$refs.cropper.getCropBlob(blob => {
				var img = window.URL.createObjectURL(blob)
				this.upBanqueImageConfig.viewImage = URL.createObjectURL(blob)
				this.upBanqueImageConfig.viewShow = true
			})
		},
		// 关闭预览
		closeViewShowModal() {
			this.upBanqueImageConfig.viewImage = ''
			this.upBanqueImageConfig.viewShow = false
		},
		random_string(e) {
			e = e || 32
			const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			const a = t.length
			let n = ''
			for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
			return n
		},
		//上传
		async handleConfirmCrop() {
			this.loading = true
			this.$refs.cropper.getCropBlob(async blob => {
				const {
					data: {url: ossUrl, cdn_url, multipart_params: multipartParams}
				} = await ossconfig()

				const formData = new FormData()
				const name = this.random_string(15) + Date.now()
				Object.keys(multipartParams).forEach(index => {
					if (index === 'key') {
						multipartParams.key += name
					}
					formData.append(index, multipartParams[index])
				})
				formData.append('file', blob, `${name}.jpg`)
				await request({url: ossUrl, method: 'post', data: formData}).then(res => {
					this.banqueInfo[this.upBanqueImageConfig.key] = cdn_url + res.data.filename
					this.closeModal()
				})
				this.loading = false
			})
		},

		/**
		 * @description: 切换样式2
		 * @return {*}
		 */
		onChangeTypeVersion(value) {
			if (value && !this.orderTypes2.length) {
				this.orderTypes2 = JSON.parse(JSON.stringify(this.orderTypes))
				this.orderTypes.forEach(item => {
					if (item.value < 6) item.label = item.label + '（样式2）'
				})
			} else {
				if (this.orderTypes2.length) {
					this.orderTypes = JSON.parse(JSON.stringify(this.orderTypes2))
					this.orderTypes2 = []
				}
			}
		},

		/**
		 * @description: 查看备注图片
		 * @return {*}
		 * @param {*} item
		 */
		checkBackupImage(item) {
			this.previewVisible = true
			let previewImage = []
			let targetImage = item.order_info.remark?.image

			if (targetImage) {
				if (typeof targetImage === 'string') {
					previewImage.push(targetImage)
				} else {
					previewImage = targetImage
				}
			}

			this.previewImage = previewImage
		},

		/**
		 * @description: 监听时间选择面板开关
		 * @return {*}
		 */
		onChangePanel(val) {
			if (!val && this.customOrderTime) {
				const customTime = this.customOrderTime.format('HH:mm')
				const timeRange = this.timeList[this.orderType]

				if (customTime < timeRange[0] || customTime > timeRange[timeRange.length - 2]) {
					this.$message.error(`请选择${timeRange[0]}到${timeRange[timeRange.length - 2]}区间内的时间`)

					this.customOrderTime = null
					this.currentOrderForm.order_time = timeRange[0]
				}
			}
		}
	}
}
</script>

<style lang="less" scoped>
input[type='number'] {
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	height: 100%;
	width: 100%;
	min-height: 100px;
	opacity: 0;
	z-index: 10;
	color: #fff;
	overflow: hidden;
	width: 200%;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	height: auto;
	-webkit-appearance: none;
}

.ant-tabs-tab-active {
	font-weight: 700;
}

.ant-tooltip {
	z-index: 99999999 !important;
}

.primary_exchange {
	color: #30c383 !important;
	border-color: #30c383 !important;
	text-shadow: none;
}

.font-bold {
	font-weight: 500 !important;
}

.dashboard-wrap {
	background-color: #f0f2f5;
	padding: 24px;
}

.first-login {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background-size: cover;
	background-repeat: no-repeat;
	height: calc(100vh - 66px);
	background-image: url(~@/assets/first-login.svg);
}

.first-login-form {
	width: 680px;
	height: 279px;
	background: #ffffff;
	box-shadow: 0 10px 29px 0 #ffdbdb;
	border-radius: 8px;
	box-sizing: border-box;
	padding: 0 69px;
	overflow: hidden;
}

.first-login-help {
	font-size: 13px;
	color: #e63e30;
	line-height: 23px;
	/*margin-top: 7px;*/
}

.dashboard {
	width: 100%;
	min-height: 100%;
	background-color: white;
	box-sizing: border-box;
	position: relative;
	border-radius: 4px;
	padding: 25px 22px;
}

.options-bar {
	box-sizing: border-box;
	// overflow: hidden;
	display: flex;
	flex-wrap: wrap;
	margin-top: 9px;
}

.options-bar > div {
	margin-right: 25px;
	margin-bottom: 25px;
}

.options-bar > .options-bar-date {
	width: 20rem;
}

.room-list {
	min-height: calc(100vh - 292px);
}

.room {
	width: 100%;
	height: 174px;
	border-radius: 4px;
	overflow: hidden;
	box-sizing: border-box;
	background: #f9f9f9;
	border: 1px solid #e8e8e8;
	cursor: pointer;
}

.room:hover {
	box-shadow: 0 2px 8px 1px #f2f2f2;
}

.room-main {
	width: 100%;
	height: 132px;
	border-bottom: 1px solid #e8e8e8;
	box-sizing: border-box;
	// padding: 12px;
}

.room-footer {
	width: 100%;
	background-color: white;
	font-size: 14px;
	line-height: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	user-select: none;
	height: 40px;
	border-radius: 0 0 2px 2px;
}

.room-status {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 12px;
	height: 40px;
	font-size: 14px;
	line-height: 40px;
	color: #666;
}

.room-name-box {
	display: flex;
	justify-content: center;
	align-items: center;
	.tag {
		padding: 0 5px;
		margin-left: 4px;
		height: 24px;
		background: #e63e30;
		border-radius: 12px;
		font-family: PingFangSC-Medium;
		font-size: 14px;
		color: #ffffff;
		text-align: center;
		line-height: 24px;
	}
}

.room-name-icon {
	width: 20px;
	height: 20px;
	margin-left: 5px;
	display: block;
}

.room-name {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	display: flex;
	justify-content: center;
	align-items: center;
	height: calc(100% - 60px);
}

.subscribe-info {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: calc(100% - 70px);
	margin-top: 10px;
}

.subscribe-info > .flex > .flex {
	justify-content: center;
	align-items: center;
	word-break: keep-all;
}

.subscribe-info .flexcolumn {
	flex-direction: column;
	align-items: center;
}

.subscribe-info .flexcolumn .vip_box {
	margin-top: 4px;
}

.subscribe-info .vip_box {
	display: flex;
	align-items: center;
	margin-left: 4px;
}

.subscribe-info .vip_box .lf {
	height: 16px;
	background: #d6ab6b;
	border-radius: 3px 0 0 3px;
	font-weight: 600;
	font-size: 10px;
	padding: 0 3px;
	line-height: 16px;
}

.subscribe-info .vip_box .rg {
	height: 16px;
	background: #6c593d;
	font-weight: Bold;
	font-size: 12px;
	line-height: 16px;
	padding: 0 3px;
	border-radius: 0 3px 3px 0;
}

.room-active {
	cursor: auto;
}

.room-active .room-main {
	width: 100%;
	height: 132px;
	background-color: #fff;
	border-radius: 4px 4px 0 0;
	color: #333;
}

.room-active .room-status {
	color: #fff;
}

.is-booking {
	border: 1px solid #ffbeb7;
}

.is-booking a {
	color: #e63e30;
}

.is-booking:hover {
	box-shadow: 0 2px 8px 1px #ffdcdc;
}

.is-booking .room-status {
	background-image: linear-gradient(90deg, #e63e30 0%, #fd786d 100%);
}

.is-booking .main_vip {
	background-image: url(~@/assets/vip_red.png), linear-gradient(90deg, #e63e30 0%, #fd786d 100%) !important;
	background-position: right, top;
	background-repeat: no-repeat, no-repeat;
	background-size: auto 103%, cover;
}

/*已到点*/

.is-timeout {
	border: 1px solid #ffceb6;
}

.is-timeout a {
	color: #fc723f;
}

.is-timeout:hover {
	box-shadow: 0 2px 8px 1px #ffece0;
}

// .is-timeout > .room-main {
//   background-image: linear-gradient(270deg, #feab73 0%, #fc723f 100%);
// }

.is-timeout .room-status {
	background-image: linear-gradient(270deg, #feab73 0%, #fc723f 100%);
}

.is-timeout .main_vip {
	background-image: url(~@/assets/vip_og.png), linear-gradient(270deg, #feab73 0%, #fc723f 100%) !important;
	background-position: right, top;
	background-repeat: no-repeat, no-repeat;
	background-size: auto 103%, cover;
}

/*已确认*/

.is-submit {
	border: 1px solid #b5eaee;
}

.is-submit a {
	color: #09afe1;
}

.is-submit:hover {
	box-shadow: 0 2px 8px 1px #dbfcff;
}

.is-submit .room-status {
	background-image: linear-gradient(269deg, #1edbea 2%, #08aee1 96%);
}

.is-submit .main_vip {
	background-image: url(~@/assets/vip_blue.png), linear-gradient(269deg, #1edbea 2%, #08aee1 96%) !important;
	background-position: right, top;
	background-repeat: no-repeat, no-repeat;
	background-size: auto 103%, cover;
}

/*已占座 、客已到*/

.is-seat {
	border: 1px solid #c5ebda;
}

.is-seat a {
	color: #32c485;
}

.is-seat:hover {
	box-shadow: 0 2px 8px 1px #eafff6;
}

// .is-seat > .room-main {
//   background-image: linear-gradient(90deg, #2dc181 0%, #63e2ab 98%);
// }

.is-seat .room-status {
	background-image: linear-gradient(90deg, #2dc181 0%, #63e2ab 98%);
}

.is-seat .main_vip {
	background-image: url(~@/assets/vip_green.png), linear-gradient(90deg, #2dc181 0%, #63e2ab 98%) !important;
	background-position: right, top;
	background-repeat: no-repeat, no-repeat;
	background-size: auto 103%, cover;
}

.dashboard-empty {
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	line-height: 24px;
	color: #999999;
	height: calc(100vh - 114px);
}

.room-list-empty {
	height: calc(100vh - 290px);
}

.dashboard-empty > img {
	width: 432px;
	height: 250px;
	margin-bottom: 12px;
}

.line-right:nth-child(2)::after {
	content: '';
	width: 1px;
	height: 16px;
	background: #e6e6e6;
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
}

/*tabs样式*/
.ant-tabs-bar {
	margin-bottom: 25px;
}

.tips {
	width: 316px;
	height: 52px;
	display: flex;
	align-items: center;
	position: absolute;
	left: 16px;
	bottom: 0;
	font-size: 14px;
	color: #e43937;
	line-height: 18px;
}

.time-list {
	display: flex;
	flex-wrap: wrap;
	grid-template-columns: repeat(5, 1fr);
	gap: 10px;
}

.time-item {
	height: 40px;
	width: 76px;
	background: rgba(0, 0, 0, 0.02);
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 2px;
	font-weight: 400;
	font-size: 16px;
	color: rgba(0, 0, 0, 0.65);
	line-height: 40px;
	text-align: center;
	cursor: pointer;
	user-select: none;
}

.time-item-range:active {
	background: #fff4f4;
	border: 1px solid #e63e30;
	color: #e63e30;
}

.time-item-active {
	background: #fff4f4;
	border: 1px solid #e63e30;
	color: #e63e30;
}

.change-room-cate {
	height: 40px;
	line-height: 40px;
	font-size: 16px;
	color: #666666;
	text-align: center;
	background: #ffffff;
	border: 1px solid #d9d9d9;
	border-radius: 2px;
	cursor: pointer;
	user-select: none;
	margin-bottom: 12px;
}

.change-room-cate:hover,
.change-room-cate-active {
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid #e63e30;
	color: #e63e30;
}

.room-remark {
	width: 50%;
	margin-left: 8px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}

.qr-code {
	width: 260px;
	background: #ffffff;
	border: 1px solid #ececec;
	border-radius: 2px;
	position: relative;
	box-sizing: border-box;
	padding: 10px;

	img {
		width: 100%;
		height: 100%;
	}

	.qr-code-mask {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 2px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.pay-tips {
	margin-top: 6px;
	width: 260px;
	height: 50px;
	font-size: 12px;
	color: #e63e30;
	line-height: 18px;
	background: #fff4f3;
	border-radius: 2px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 7px 15px;
}

.status_box {
	display: flex;
	align-items: center;

	.status {
		display: flex;
		align-items: center;
		margin-right: 12px;
	}

	.status-line {
		width: 1px;
		height: 20px;
		background: #e6e6e6;
	}

	.status-icon {
		margin-right: 15px;
		width: 22px;
		height: 22px;
		vertical-align: middle;
		&:hover {
			cursor: pointer;
		}
	}

	.text {
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}

	.circle {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		display: block;
		margin-right: 8px;
	}

	.circle_1 {
		background: #f9f9f9;
		border: 1px solid #d8d8d8;
	}

	.circle_2 {
		background-image: linear-gradient(90deg, #e63e30 0%, #fc776c 99%);
		border: 1px solid #ffbeb7;
	}

	.circle_3 {
		background-image: linear-gradient(90deg, #08aee1 0%, #1edbe9 98%);
		border: 1px solid #b5eaee;
	}

	.circle_4 {
		background-image: linear-gradient(90deg, #fb7542 0%, #fea871 96%);
		border: 1px solid #ffceb6;
	}

	.circle_5 {
		background-image: linear-gradient(90deg, #2ec282 0%, #63e2aa 99%);
		border: 1px solid #c5ebda;
	}
}

.customer-tag {
	font-weight: bold;
	font-size: 10px;
	line-height: 1;
	border-radius: 3px;
	padding: 5px;
	color: #ffffff;
	margin-left: 4px;
}

.customer-tag.tag-1 {
	background: #6c593d;
}

.customer-tag.tag-2 {
	background: #896a3c;
}

.customer-tag.tag-3 {
	background: #af8c57;
}

.customer-tag.tag-4 {
	background: #d6ab6b;
}

.name-wrapper {
	flex-wrap: wrap;
	.ant-btn {
		margin-bottom: 8px;
	}
}

.search-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-top: 20px;

	.search-title {
		position: relative;
		font-size: 18px;
		font-weight: bold;
		color: #333;
	}

	.search-title::before {
		position: absolute;
		left: -68px;
		top: 14px;
		content: '';
		width: 60px;
		height: 1px;
		background-image: linear-gradient(270deg, #e6e6e6 0%, #ffffff 99%);
		margin-right: 8px;
	}

	.search-title::after {
		position: absolute;
		right: -68px;
		top: 14px;
		content: '';
		width: 60px;
		height: 1px;
		background-image: linear-gradient(90deg, #e6e6e6 1%, #ffffff 100%);
	}

	.search-tips {
		padding: 5px 6px;
		margin: 6px 0 13px 0;
		background: #fff6ef;
		border-radius: 18px;
		font-size: 12px;
		color: #f8a23e;
	}

	.search-box {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-width: 240px;

		.search-box-list {
			display: flex;
			align-items: center;
			justify-content: space-between;
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			height: 100%;
			width: 100%;
			min-height: 60px;

			.search-item {
				width: 40px !important;
				height: 40px !important;
				text-align: center;
				border: 1px solid #999;
				border-radius: 8px;
				font-size: 24px;
				color: #333;

				.search-item_focus {
					height: 100%;
					width: 100%;
					-webkit-animation-name: opacity;
					-webkit-animation-timing-function: ease-in-out;
					-webkit-animation-iteration-count: infinite;
					-webkit-animation-duration: 1s;
					box-sizing: border-box;
				}

				@keyframes opacity {
					0% {
						opacity: 1;
					}

					100% {
						opacity: 0;
					}
				}
			}
		}
	}
}

.room-small-card {
	width: 100%;
	.card-title {
		margin-bottom: 15px;
		width: 100%;
		height: 20px;
		font-family: PingFangSC-SNaNpxibold;
		font-weight: 600;
		font-size: 18px;
		color: #333;
		line-height: 20px;
	}
	.card-list {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 15px;
	}
	.card-item {
		position: relative;
		padding: 10px 0 0 10px;
		margin: 0 10px 10px 0;
		width: 140px;
		height: 96px;
		border-radius: 6px;
		color: #fff;
		&:hover {
			cursor: pointer;
		}
		.tag {
			position: absolute;
			top: -5px;
			right: -5px;
			padding: 0 5px;
			height: 24px;
			background: #e63e30;
			border-radius: 12px;
			font-family: PingFangSC-Medium;
			font-size: 16px;
			color: #ffffff;
			text-align: center;
			line-height: 24px;
		}
		.item-line {
			position: absolute;
			bottom: 26px;
			left: 0;
			right: 0;
			margin: 0 auto;
			width: 100%;
			height: 1px;
			background-color: #e6e6e6;
		}
		.item-name {
			height: 20px;
			font-family: PingFangSC-SNaNpxibold;
			font-weight: 600;
			font-size: 18px;
			color: #333;
			line-height: 20px;
			white-space: nowrap; /* 禁止换行 */
			overflow: hidden; /* 隐藏溢出内容 */
			text-overflow: ellipsis; /* 显示省略号 */
		}
		.item-info,
		.item-phone {
			height: 16px;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			font-size: 14px;
			color: #666;
			line-height: 16px;
		}
		.item-info {
			position: relative;
			margin-top: 12px;
			display: inline-flex;
			align-items: center;
			gap: 8px;
			p {
				max-width: 100px;
				white-space: nowrap; /* 禁止换行 */
				overflow: hidden; /* 隐藏溢出内容 */
				text-overflow: ellipsis; /* 显示省略号 */
			}
			.remark {
				width: 18px;
				height: 18px;
				background: #ffffff;
				border-radius: 4px;
				text-align: center;
				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 14px;
				color: #ff8018;
				line-height: 18px;
			}
		}
		.item-phone {
			margin-top: 8px;
		}
		.item-bottom {
			margin: 6px 10px 0 0;
			height: 28px;
			text-align: center;
			font-family: PingFangSC-Regular;
			font-size: 14px;
			color: #666;
			line-height: 28px;
		}
		.item-status {
			position: absolute;
			bottom: 0;
			right: 0;
			width: 50px;
			height: 50px;
			vertical-align: middle;
		}
	}
	.card-item-checked {
		.item-name,
		.item-info,
		.item-phone {
			color: #fff;
		}
	}
	.card-item-disabled {
		.item-name,
		.item-info,
		.item-phone {
			color: #999;
		}
	}
}

// 未预订
.card-status-00 {
	background: #ffffff;
	border: 1px solid #e6e6e6;
	box-shadow: 0 2px 8px 1px #f2f2f2;
}

// 已预订
.card-status-01 {
	background-image: linear-gradient(90deg, #e63e30 0%, #fd786d 98%);
	border: 0;
	box-shadow: 0 2px 8px 1px #ffd8d8;
}

// 已到点
.card-status-02 {
	background-image: linear-gradient(90deg, #fb7340 0%, #feaa73 98%);
	border: 0;
	box-shadow: 0 2px 8px 1px #ffe4d2;
}

// 已禁用
.card-status-03 {
	background: #e6e6e6;
	border: 0;
	box-shadow: 0 2px 8px 1px #f2f2f2;
}

// 已确认
.card-status-04 {
	background-image: linear-gradient(90deg, #08afe1 0%, #1fdcea 98%);
	border: 0;
	box-shadow: 0 2px 8px 1px #dcfcff;
}

// 已占座/客已到
.card-status-05 {
	background-image: linear-gradient(90deg, #2ec282 0%, #64e3ab 98%);
	border: 0;
	box-shadow: 0 2px 8px 1px #d7ffee;
}

// 小卡片订单详情弹窗
.detail-wrapper {
	position: relative;
	padding: 20px 15px 0;
	width: 100%;
	background: #ffffff;
	border: 1px solid #ffbeb7;
	border-radius: 6px;
	box-sizing: border-box;
	.detail-title {
		margin-bottom: 15px;
		height: 20px;
		font-family: PingFangSC-Medium;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
		line-height: 20px;
	}
	.detail-status {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 32px;
		border-radius: 0 0 5px 5px;
		border-radius: 0 0 5px 5px;
		font-family: PingFangSC-Medium;
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		text-align: center;
		line-height: 32px;
	}
	// 已预订
	.detail-status-01 {
		background-image: linear-gradient(90deg, #e63e30 0%, #fc8040 100%);
	}
	// 已到点
	.detail-status-02 {
		background-image: linear-gradient(90deg, #fc6831 0%, #febe86 100%);
	}
	// 客已到/已占座
	.detail-status-05 {
		background-image: linear-gradient(90deg, #23b174 0%, #91d28f 100%);
	}
	// 已确认
	.detail-status-04 {
		background-image: linear-gradient(90deg, #08aee0 0%, #39d8c6 100%);
	}
	.detail-row {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		width: 100%;
		&:last-child {
			margin-bottom: 48px;
		}
		p {
			height: 18px;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			font-size: 16px;
			color: #666666;
			line-height: 18px;
		}
	}
}

.detail-row-check {
	height: 18px;
	padding: 0 4px;
	border: 1px solid #bbbbbb;
	border-radius: 4px;
	font-size: 12px !important;
	line-height: 18px;
	cursor: pointer;
}

// 已预订
.detail-wrapper-01 {
	border: 1px solid #ffbeb7;
}

// 已到点
.detail-wrapper-02 {
	border: 1px solid #ffceb6;
}

// 客已到/已占座
.detail-wrapper-05 {
	border: 1px solid #c5ebda;
}

// 已确认
.detail-wrapper-04 {
	border: 1px solid #b5eaee;
}

.options-wrapper {
	gap: 20px; /* 控制按钮间距 */
	flex-wrap: nowrap; /* 禁止换行 */
	margin-top: 15px;
	.options-item {
		flex-direction: column;
		width: 110px;
		height: 88px;
		background: #ffffff;
		box-shadow: 0 0 18px 0 #0000000f;
		border-radius: 12px;
		&:hover {
			cursor: pointer;
		}
		.options-icon {
			width: 42px;
			height: 42px;
			vertical-align: middle;
		}
		p {
			margin-top: 6px;
			height: 16px;
			font-family: PingFangSC-Medium;
			font-weight: 500;
			font-size: 14px;
			color: #333333;
			text-align: center;
			line-height: 16px;
		}
	}
}

.scroll-top {
	position: fixed;
	bottom: 100px;
	right: 36px;
	cursor: pointer;
	img {
		width: 50px;
		height: 50px;
		vertical-align: middle;
	}
}

.scroll-refresh {
	position: fixed;
	bottom: 50px;
	right: 40px;
	cursor: pointer;
	img {
		width: 42px;
		height: 42px;
		vertical-align: middle;
	}
}

// 禁用状态
.disableCart {
	.room-status {
		background: #e6e6e6;
		color: #999999;
	}
	.subscribe-info,
	.room-footer,
	a,
	.text-dark {
		color: #999999 !important;
	}
	.card-item {
		background: #e6e6e6;
		border: 0;
		box-shadow: 0 2px 8px 1px #f2f2f2;
		.item-name,
		.item-info,
		.item-phone {
			color: #999999;
		}
	}
}
.banquetListRadion {
	display: flex;
	align-items: center;
	overflow-x: scroll;
	padding-bottom: 10px;
}
// 预览效果
.imageCropperView-box {
	height: 274px;
	width: 297px;
	box-sizing: border-box;
	position: relative;
	display: flex;
	justify-content: center;
}

.imageCropperView-invitation_img-bg {
	height: 100%;
	width: 100%;
}

.imageCropperView-invitation_imgbox {
	height: 440px;
	width: 219px;
	padding: 0;
}

.imageCropperView-bg {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
	z-index: 12;
}

.imageCropperView-menu {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
	z-index: 10;
}

.imageCropperView-theme_img {
	height: 100%;
	width: 85%;
	-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0.9) 70%, rgba(0, 0, 0, 0.5) 80%, rgba(0, 0, 0, 0.2) 90%, rgba(0, 0, 0, 0) 100%);
	mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 60%, rgba(0, 0, 0, 0.9) 70%, rgba(0, 0, 0, 0.5) 80%, rgba(0, 0, 0, 0.2) 90%, rgba(0, 0, 0, 0) 100%);
	border-radius: 50px 50px 0 0;
}
.imageCropperView-invitation_img {
	z-index: 11;
	position: absolute;
	top: 115px;
	right: 48px;
	width: 110px;
	height: 88px;
}
.imageCropperView-menu_img {
	z-index: 11;
	position: absolute;
	top: 140px;
	left: 22px;
	height: 50px;
	border-radius: 40px 40px 0 0;
	width: 85%;
	-webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0) 100%);
	mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.5) 40%, rgba(0, 0, 0, 0.3) 60%, rgba(0, 0, 0, 0) 100%);
}

// 打印预览
.orderA4Print_class {
	display: flex;
	justify-content: space-between;
	.orderA4Print_checkbox {
		flex: 1;
		margin: 0 10px;
	}
}
.orderA4Print_thead {
	width: 100%;
	text-align: center;
	color: #000;
}
// A4打印
.shop_title {
	font-size: 40px;
	font-weight: 500;
	text-align: center;
}

.orderA4Print_info {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px;
}
.orderA4Print_table {
	.orderA4Print_class_name {
		font-size: 24px;
		font-weight: 500;
		text-align: center;
		padding: 10px 0;
	}
}
</style>
